// import {
//   AddPhotoAlternate,
//   CancelTwoTone,
//   CloudUpload as CloudUploadIcon,
//   InfoOutline,
// } from "@mui/icons-material";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   Container,
//   Divider,
//   Grid,
//   Modal,
//   Paper,
//   Tooltip,
//   Typography,
// } from "@mui/material";
// import { useFormik } from "formik";
// import lodash, { values } from "lodash";
// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import * as Yup from "yup";
// import api, { baseImageUrl } from "../../../../api";
// import videoIcon from "../../../../components/assets/video.svg";
// import FieldErrorText from "../../../../components/ui/FieldErrorText";
// import { setAlertDialog } from "../../../../toolkit/alertDialog/alertDialogSlice";
// import { useLazyUpdateCarQuery } from "../../../../toolkit/myGarage/myGarageApi";
// import { setGalleryForm } from "../../../../toolkit/myGarage/myGarageSlice";
// import NavigationButtons from "../NavigationButtons";
// import {
//   addImageContent,
//   imagePlaceholderIcon,
//   addImageText,
//   cardButtonStyle,
//   carfaxDisclaimer,
//   carfaxFullSection,
//   carfaxHeadline,
//   carFaxLink,
//   carfaxSubHeadline,
//   exampleImagesContainer,
//   hiddenFileInput,
//   imageGridContainer,
//   imageInputContainer,
//   imagesGridContainer,
//   imageStyle,
//   mainContainere,
//   paperContainer,
//   paypalButtonsGroup,
//   paypalButtonStyle,
//   sectionTitle,
//   subtitleText,
//   uploadButton,
//   videoUploadContainer,
// } from "./GallerySx";
// import { backendMappedValuesStep1 } from "./GeneralInfo";
// import { emptyFieldsPartialForm } from "./utils/emptyFieldsPartialForm";
// import VehicleAddedModal from "./VehicleAddedSuccessModal";
// import theme from "../../../../theme";
// import ViewVideoModal from "../../../../components/custom/ViewVideoModal";
// import ExampleImagesPopup from "./ExampleImagesPopup";
// import extImgEx1 from "../../../../components/assets/ext-img-ex1.svg";
// import extImgEx2 from "../../../../components/assets/ext-img-ex2.svg";
// import extImgEx3 from "../../../../components/assets/ext-img-ex3.svg";
// import intImgEx1 from "../../../../components/assets/int1.avif";
// import intImgEx2 from "../../../../components/assets/int2.avif";
// import intImgEx3 from "../../../../components/assets/int3.avif";
// import rimsImgEx1 from "../../../../components/assets/rims1.avif";
// import rimsImgEx2 from "../../../../components/assets/rims2.avif";
// import rimsImgEx3 from "../../../../components/assets/rims3.avif";
// import { errorContainer } from "./QuestionareSx";
// import { useCreatePaypalOrderMutation } from "../../../../toolkit/paypal/paypalApi";
// import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
// import { useCompleteCarfaxPaymentMutation, useLazyGetCarfaxReportQuery } from "../../../../toolkit/carfax/carfaxApi";
// import PdfViewer from "../../../../components/custom/PdfViewer";

// const ImageDeleteContainer = ({ imageList, formik, idx }) => {
//   return (
//     <Box
//       sx={{
//         position: "absolute",
//         top: "0",
//         right: "0",
//         zIndex: "20",
//       }}
//     >
//       <Button
//         sx={{
//           padding: "0",
//           minWidth: "0",
//         }}
//         onClick={(e) => {
//           e.stopPropagation();
//           e.preventDefault();

//           formik.setValues((values) => {
//             return {
//               ...values,
//               images: {
//                 ...values?.images,
//                 [imageList]: values?.images?.[imageList]?.map?.(
//                   (item, itemIdx) => {
//                     if (itemIdx === idx) {
//                       return "";
//                     } else {
//                       return item;
//                     }
//                   }
//                 ),
//               },
//             };
//           });
//         }}
//       >
//         <CancelTwoTone
//           sx={{
//             color: theme.palette.text.primary,
//           }}
//         />
//       </Button>
//     </Box>
//   );
// };

// const exteriorLabels = ["Front", "Driver Side", "Passenger Side", "Back"];
// const interiorLabels = ["Dashboard", "Console", "Steering Wheel", "Back Seat"];
// const rimsLabels = ["Front Left", "Front Right", "Rear Left", "Rear Right"];
// const damageLabels = ["Damage 1", "Damage 2", "Damage 3", "Damage 4"];

// const Gallery = ({ goBackHandler, onSuccessCallback, previousFormHandler }) => {
//   const storedVehicleId = "1992";

//   // useRef start...
//   const imagesInputsRef = React.useRef({
//     interior: ["", "", "", ""],
//     exterior: ["", "", "", ""],
//     rims: ["", "", "", ""],
//     other: ["", "", "", ""],
//     damage: ["", "", "", ""],
//   });

//   const onMountRef = React.useRef({
//     images: false,
//     setGalleryForm: false
//   });
//   // useRef end...

//   const dispatch = useDispatch();
//   const auth = useSelector((store) => store.auth);
//   const { forms, previouslySubmittedForms, vehicle_id, isEditing } = useSelector(
//     (store) => store.myGarage
//   );

//   const generalInfoForm = forms?.generalInfo;
//   const questionareForm = forms?.questionare;
//   const specificationsForm = forms?.specifications;
//   const galleryForm = forms?.gallery;

//   const [updateCarApiHandler, updateCarApiData] = useLazyUpdateCarQuery();
//   const [createPaypalOrderApiHandler, createPaypalOrderApiData] = useCreatePaypalOrderMutation();
//   const [completeCarfaxPaymentApiHandler, completeCarfaxPaymentApiData] = useCompleteCarfaxPaymentMutation();
//   const [getCarfaxReportApiHandler, getCarfaxReportApiData] = useLazyGetCarfaxReportQuery();

//   const validationSchema = Yup.object({
//     images: Yup.object().shape({
//       "Exterior Of The Car": Yup.array(),
//       "Interior Of The Car": Yup.array(),
//       "Rims Of The Car": Yup.array(),
//       // "Other Pictures": Yup.array(),
//       "Damage Photos": Yup.array(),
//     })
//     .test(
//       "all-image-arrays-not-empty", // Name of the test
//       "Please upload at least one image for each category.", // Default error message
//       function (imagesObj) {
//         // `imagesObj` here is the value of the `images` object being validated.
//         // It will be something like:
//         // {
//         //   "Exterior Of The Car": ["url1", "", "url2", ""],
//         //   "Interior Of The Car": ["url3", "", "", ""],
//         //   // ... and so on
//         // }

//         if (!imagesObj) {
//           // If the images object itself is null or undefined, consider it invalid.
//           return false;
//         }

//         // Get all the keys (category names) from the images object
//         const categories = Object.keys(imagesObj);

//         // Iterate over each category and check its corresponding array
//         const allCategoriesHaveAtLeastOneImage = categories.every(
//           (categoryName) => {
//             const imageArray = imagesObj[categoryName];

//             // Ensure it's an array and contains at least one non-empty string
//             return (
//               Array.isArray(imageArray) &&
//               imageArray.some((str) => str)
//             );
//           }
//         );

//         console.log(imagesObj, `imagesObj`)

//         // If any category fails the check, this overall test fails.
//         if (!allCategoriesHaveAtLeastOneImage) {
//           // You can use `this.createError` for more granular error messages if needed,
//           // but for a single message for the entire object, returning false is fine.
//           return this.createError({
//             path: this.path, // Path to the 'images' object
//             message: "Please upload at least one image for each category.",
//           });
//         }

//         return true; // All checks passed
//       }
//     ),
//     Vehicle_video: Yup.mixed().required("Video is mandatory!"),
//   });

//   const initialValues = {
//     images: {
//       "Exterior Of The Car": ["", "", "", ""] /*[]*/,
//       "Interior Of The Car": ["", "", "", ""] /*[]*/,
//       "Rims Of The Car": ["", "", "", ""] /*[]*/,
//       // "Other Pictures": ["", "", "", ""] /*[]*/,
//       "Damage Photos": ["", "", "", ""] /*[]*/,
//     },
//     Vehicle_video: null,
//   };

//   const formik = useFormik({
//     initialValues,
//     validationSchema,
//     onSubmit: async (values) => {
//       const payload = {};

//       // for (let i = 0; i < Object.entries(emptyFieldsPartialForm)?.length; i++) {
//       //   payload[[Object.entries(emptyFieldsPartialForm)?.[i]?.[0]]] =
//       //     Object.entries(emptyFieldsPartialForm)?.[i]?.[1];
//       // }

//       // const formData = new FormData();
//       for (
//         let i = 0;
//         i < values?.images?.["Interior Of The Car"]?.length;
//         i++
//       ) {
//         if (typeof values?.images?.["Interior Of The Car"]?.[i] !== "string") {
//           // const fileName = values?.images?.["Interior Of The Car"]?.[
//           //   i
//           // ].substring(
//           //   values?.images?.["Interior Of The Car"]?.[i].lastIndexOf("/") + 1
//           // );
//           // payload[`Interior_Image${i + 1}`] = fileName;
//           // // formData.append(`Interior_Image${i + 1}`, fileName);

//           payload[`Interior_Image${i + 1}`] =
//             values?.images?.["Interior Of The Car"]?.[i];
//         } else if (values?.images?.["Interior Of The Car"]?.[i] === "") {
//           payload[`Interior_Image${i + 1}`] =
//             values?.images?.["Interior Of The Car"]?.[i];
//           // formData.append(`Interior_Image${i + 1}`, values?.images?.["Interior Of The Car"]?.[i]);
//         }
//       }

//       for (
//         let i = 0;
//         i < values?.images?.["Exterior Of The Car"]?.length;
//         i++
//       ) {
//         if (typeof values?.images?.["Exterior Of The Car"]?.[i] !== "string") {
//           // const fileName = values?.images?.["Exterior Of The Car"]?.[
//           //   i
//           // ].substring(
//           //   values?.images?.["Exterior Of The Car"]?.[i].lastIndexOf("/") + 1
//           // );
//           // payload[`Exterior_Image${i + 1}`] = fileName;
//           // // formData.append(`Exterior_Image${i + 1}`, fileName);

//           payload[`Exterior_Image${i + 1}`] =
//             values?.images?.["Exterior Of The Car"]?.[i];
//         } else if (values?.images?.["Exterior Of The Car"]?.[i] === "") {
//           payload[`Exterior_Image${i + 1}`] =
//             values?.images?.["Exterior Of The Car"]?.[i];
//           // formData.append(`Exterior_Image${i + 1}`, values?.images?.["Exterior Of The Car"]?.[i]);
//         }
//       }

//       for (let i = 0; i < values?.images?.["Rims Of The Car"]?.length; i++) {
//         if (typeof values?.images?.["Rims Of The Car"]?.[i] !== "string") {
//           // const fileName = values?.images?.["Rims Of The Car"]?.[i].substring(
//           //   values?.images?.["Rims Of The Car"]?.[i].lastIndexOf("/") + 1
//           // );
//           // payload[`Rims_Image${i + 1}`] = fileName;
//           // // formData.append(`Rims_Image${i + 1}`, fileName);

//           payload[`Rims_Image${i + 1}`] =
//             values?.images?.["Rims Of The Car"]?.[i];
//         } else if (values?.images?.["Rims Of The Car"]?.[i] === "") {
//           payload[`Rims_Image${i + 1}`] =
//             values?.images?.["Rims Of The Car"]?.[i];
//           // formData.append(`Rims_Image${i + 1}`, values?.images?.["Rims Of The Car"]?.[i]);
//         }
//       }

//       for (let i = 0; i < values?.images?.["Damage Photos"]?.length; i++) {
//         if (typeof values?.images?.["Damage Photos"]?.[i] !== "string") {
//           // const fileName = values?.images?.["Damage Photos"]?.[i].substring(
//           //   values?.images?.["Damage Photos"]?.[i].lastIndexOf("/") + 1
//           // );
//           // payload[`Dashboard_Image${i + 1}`] = fileName;
//           // // formData.append(`Dashboard_Image${i + 1}`, fileName);

//           payload[`Dashboard_Image${i + 1}`] =
//             values?.images?.["Damage Photos"]?.[i];
//         } else if (values?.images?.["Damage Photos"]?.[i] === "") {
//           payload[`Dashboard_Image${i + 1}`] =
//             values?.images?.["Damage Photos"]?.[i];
//           // formData.append(`Dashboard_Image${i + 1}`, values?.images?.["Damage Photos"]?.[i]);
//         }
//       }

//       if (typeof values?.Vehicle_video !== "string") {
//         payload[`Vehicle_video`] = values?.Vehicle_video;
//       } else if (values?.Vehicle_video === "") {
//         payload[`Vehicle_video`] = values?.Vehicle_video;
//       }

//       // STEP4 end

//       const formData = new FormData();

//       for (let i = 0; i < Object.entries(payload).length; i++) {
//         formData.append(
//           Object.entries(payload)?.[i]?.[0],
//           Object.entries(payload)?.[i]?.[1]
//         );
//       }

//       formData.append(`Seller_Id`, auth?.user_id);

//       const editMode = "normaledit";

//       if (!lodash?.isEqual(previouslySubmittedForms?.gallery, formik?.values)) {
//         const response = await updateCarApiHandler({
//           formData,
//           endpoint: `/updatevehicle/${vehicle_id}/${editMode}`,
//         });

//         if (response?.isError) {
//           dispatch(
//             setAlertDialog({
//               open: true,
//               title: `Error!`,
//               message: response?.error?.message || "Some error occured!",
//             })
//           );
//         }
//       } else {
//         setIsSuccess(true);
//       }
//     },
//   });

//   // useState variables start...
//   const [isSuccess, setIsSuccess] = React.useState(false);
//   const [openViewVideoModal, setOpenViewVideoModal] = useState(false);
//   const [paypalOrderId, setPaypalOrderId] = React.useState(null);
//   const [isCarfaxPaymentDone, setIsCarfaxPaymentDone] = React.useState(false);
//   const [carfaxReportUrl, setCarfaxReportUrl] = React.useState("");
//   // useState variables end...

//   // Handlers start...
//   const handleVideoChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       formik.setFieldValue("Vehicle_video", file);
//     }
//   };

//   const handleCarfaxPayment = async () => {
//     const storedVehicleId = vehicle_id;
//     const script = document.createElement("script");
//     script.src = `https://www.paypal.com/sdk/js?client-id=AUJsTBrdpNk9-KgCgsf9KvoCQhYUE2lWgclrEj-4B2qt8jwijj9LdvTeKuJWRjwRxNSbUSIiKDoesg0x&currency=CAD&locale=en_CA`;
//     script.async = true;

//     const loadPayPalButton = () => {
//       if (window.paypal) {
//         document.getElementById("paypal-button-container").innerHTML = "";

//         window.paypal
//           .Buttons({
//             createOrder: (data, actions) => {
//               return actions.order.create({
//                 purchase_units: [
//                   {
//                     amount: { value: "67" }, // Replace with your amount
//                     custom_id: auth?.user_id, // <<< ADD THIS LINE TO SEND USER_ID
//                   },
//                 ],
//                 application_context: {
//                   shipping_preference: "NO_SHIPPING",
//                   user_action: "PAY_NOW",
//                 },
//               });
//             },
//             onApprove: (data, actions) => {
//               return actions.order.capture().then((details) => {
//                 // setSuccessMessageCarFaxReport(
//                 //   `Transaction completed by ${details.payer.name.given_name}`
//                 // );
//                 // setTransactionComplete(true);

//                 // Call API after transaction completion
//                 const fetchCarfaxElvalutionApi = async () => {
//                   try {
//                     const carfaxResponse = await api.get(
//                       `/seller/carfaxevalvationreport/${storedVehicleId}/${generalInfoForm?.VIN}/0`
//                     );

//                     const vehicleResponse = await api.get(
//                       `/seller/vehicle/${storedVehicleId}`
//                     );
//                     const vehicleData = vehicleResponse.data;

//                     // setCarFaxUrl(vehicleData.vehicle.Carfax_Report_Url);
//                   } catch (error) {
//                     console.error("Carfax Report: Error fetching url:", error);
//                   }
//                 };

//                 fetchCarfaxElvalutionApi();
//               });
//             },
//             onError: (err) => {
//               console.error("PayPal Checkout onError", err);
//               alert(
//                 "An error occurred during the transaction. Please try again."
//               );
//             },
//           })
//           .render("#paypal-button-container");
//       }
//     };

//     script.onload = loadPayPalButton;
//     document.body.appendChild(script);
//   };

//   const createPaypalOrder = async () => {
//     const res = await createPaypalOrderApiHandler({
//       payload: {
//         amount: "67",
//         currency: "CAD",
//         vehicle_id: vehicle_id
//       }
//     });

//     if (res?.error || ("status" in res?.data && !res?.data?.status)) {
//       dispatch(
//         setAlertDialog({
//           open: true,
//           title: `Error!`,
//           message: res?.error?.data?.error || res?.error?.data?.message
//             || res?.data?.message || `Some error occured`
//         })
//       );
//       return;
//     } else {
//       setPaypalOrderId(res?.data?.paypal_order_id);
//       return res?.data?.paypal_order_id;
//     }
//   };

//   const onPaymentSuccessHandler = async (data, actions) => {

//     console.log(data, actions, `onPaymentSuccessHandler`)

//     // return actions.order.capture().then(function(details) {
//     //   // This function will be called if the capture is successful
//     //   console.log('Payment captured directly from client:', details);
//     // }).catch(function(error) {
//     //   // Handle errors during the capture process
//     //   console.error('Error capturing payment directly from client:', error);
//     // });

//     if (!data?.orderID) {
//       dispatch(
//         setAlertDialog({
//           open: true,
//           title: `Error!`,
//           message: `The payment orderID was not found. Please try again!`
//         })
//       );
//       return;
//     }

//     const res = await completeCarfaxPaymentApiHandler({
//       payload: {
//         transaction_id: data?.paymentID,
//         order_id: data?.orderID,
//         status: "COMPLETED",
//         currency_code: "CAD",
//         amount: "67",
//         vehicle_id: vehicle_id
//       }
//     });

//     if (res?.error || ("status" in res?.data && !res?.data?.status)) {
//       dispatch(
//         setAlertDialog({
//           open: true,
//           title: `Error!`,
//           message: res?.error?.data?.error || res?.error?.data?.message
//             || res?.data?.message || `Some error occured!`
//         })
//       );
//       return;
//     } else {
//       dispatch(
//         setAlertDialog({
//           open: true,
//           title: `Success!`,
//           message: `The payment was successful!`
//         })
//       );

//       await getCarfaxReportApiHandler({
//         Vehicle_Id: vehicle_id,
//         vin: generalInfoForm?.VIN,
//       });

//       setIsCarfaxPaymentDone(true);
//     }
//   }

//   const onPaymentErrorHandler = (err) => {
//     console.error('PayPal Checkout error:', err);
//     dispatch(
//       setAlertDialog({
//         open: true,
//         title: `Error!`,
//         message: err?.message || `An error occurred during PayPal checkout.`
//       })
//     );
//   };

//   const getPaypalOrderId = () => {
//     return paypalOrderId;
//   }

//   const getCarfaxReportHandler = async () => {
//     const res = await getCarfaxReportApiHandler({
//       Vehicle_Id: vehicle_id,
//       vin: generalInfoForm?.VIN
//     });

//     if (res?.isError || ("status" in res?.data && !res?.data?.status)) {
//       dispatch(
//         setAlertDialog({
//           open: true,
//           title: `Error!`,
//           message: res?.error?.data?.error || res?.error?.data?.message
//             || res?.data?.message || `Some error occured!`
//         })
//       );
//     } else {
//       setCarfaxReportUrl(res?.data?.Url || "");
//       window.open(res?.data?.Url, '_blank');
//     }
//   };
//   // Handlers end...

//   // useEffect start...
//   // React.useEffect(() => {
//   //   (async () => {
//   //     try {
//   //       const response = await api.get(
//   //         `/seller/getvehicleimages/${vehicle_id}`
//   //       );

//   //       const dashboardImages = response?.data?.Vehicle_Image?.[0]?.dashboard;
//   //       const exteriorImages = response?.data?.Vehicle_Image?.[0]?.exterior;
//   //       const interiorImages = response?.data?.Vehicle_Image?.[0]?.interior;
//   //       const rimsImages = response?.data?.Vehicle_Image?.[0]?.rims;

//   //       const mixBaseDashboardImages = [];
//   //       dashboardImages.forEach((image) => {
//   //         if (image !== null) {
//   //           mixBaseDashboardImages.push(
//   //             baseImageUrl + `${vehicle_id}/` + image
//   //           );
//   //         }
//   //       });
//   //       const mixBaseExteriorImages = [];
//   //       exteriorImages.forEach((image) => {
//   //         if (image !== null) {
//   //           mixBaseExteriorImages.push(baseImageUrl + `${vehicle_id}/` + image);
//   //         }
//   //       });
//   //       const mixBaseInteriorImages = [];
//   //       interiorImages.forEach((image) => {
//   //         if (image !== null) {
//   //           mixBaseInteriorImages.push(baseImageUrl + `${vehicle_id}/` + image);
//   //         }
//   //       });
//   //       const mixBaseRimsImages = [];
//   //       rimsImages.forEach((image) => {
//   //         if (image !== null) {
//   //           mixBaseRimsImages.push(baseImageUrl + `${vehicle_id}/` + image);
//   //         }
//   //       });

//   //       formik.setValues((values) => {
//   //         return {
//   //           ...values,
//   //           images: {
//   //             ...values?.images,
//   //             ["Interior Of The Car"]: mixBaseInteriorImages,
//   //             ["Exterior Of The Car"]: mixBaseExteriorImages,
//   //             ["Rims Of The Car"]: mixBaseRimsImages,
//   //             ["Damage Photos"]: mixBaseDashboardImages,
//   //             ["Other Pictures"]: [],
//   //           },
//   //         };
//   //       });
//   //     } catch (err) {
//   //       //
//   //     }
//   //   })();
//   // }, []);

//   React.useEffect(() => {
//     if (galleryForm) {
//       formik.setValues((values) => {
//         return {
//           ...values,
//           ...galleryForm,
//         };
//       });
//     }
//   }, []);

//   React.useEffect(() => {
//     if (onMountRef.current.setGalleryForm) {
//       dispatch(setGalleryForm(formik?.values));
//     } else {
//       onMountRef.current.setGalleryForm = true;
//     }
//   }, [formik?.values]);

//   React.useEffect(() => {
//     if (updateCarApiData?.isSuccess && !updateCarApiData?.isFetching) {
//       setIsSuccess(true);
//     }
//   }, [updateCarApiData?.isSuccess]);

//   React.useEffect(() => {
//     createPaypalOrder();
//   }, []);

//   // React.useEffect(() => {
//   //   if (onMountRef.current?.images) {
//   //     formik.setTouched({
//   //       images: true
//   //     });
//   //   } else {
//   //     onMountRef.current.images = true;
//   //   }

//   // }, [formik?.values?.images]);

//   // React.useEffect(() => {
//   //   if (forms?.gallery) {
//   //     formik.setValues(forms?.gallery);
//   //   }
//   // }, []);
//   // useEffect end...

//   console.log(formik, `Gallery_comp`)

//   return (
//     <>
//       <Paper elevation={0} sx={paperContainer}>
//         <Typography variant="body1" sx={subtitleText}>
//           Share details about your vehicle to receive a solid offer within
//           minutes.
//         </Typography>
//       </Paper>

//       <Divider />

//       <Container sx={mainContainere}>
//         <form
//           onSubmit={formik.handleSubmit}
//           style={{
//             height: "100%",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "space-between",
//           }}
//         >
//           <Box sx={{
//             display: "flex",
//             justifyContent: "center",
//             marginBottom: "2rem"
//           }}>
//             <Button
//               // variant="body1"
//               // sx={{
//               //   fontWeight: 600,
//               //   textAlign: "center",
//               // }}
//               onClick={getCarfaxReportHandler}
//             >
//               {getCarfaxReportApiData?.isFetching ? (
//                 <CircularProgress
//                   size={22}
//                 />
//               ) : (
//                 "Check your vehicle's CarFax report"
//               )}
//               {/* <a href="#" style={carFaxLink}>
//                 View
//               </a> */}
//             </Button>
//           </Box>

//           <Box sx={{ marginBottom: "2rem" }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "1rem",
//                 marginBottom: "1rem",
//               }}
//             >
//               <Typography sx={sectionTitle}>Upload Video <span style={{ color: "red" }}>*</span></Typography>
//               {formik.values?.Vehicle_video &&
//               typeof formik.values?.Vehicle_video === "string" ? (
//                 <Button
//                   sx={{
//                     padding: "0",
//                   }}
//                   onClick={() => setOpenViewVideoModal(true)}
//                 >
//                   View current video
//                 </Button>
//               ) : null}
//             </Box>

//             <Box sx={videoUploadContainer}>
//               <Box>
//                 <img
//                   src={videoIcon}
//                   style={{
//                     width: "2rem",
//                   }}
//                 />
//               </Box>
//               <Box sx={{ flex: 1, textAlign: "center" }}>
//                 {formik.values?.Vehicle_video &&
//                 typeof formik.values?.Vehicle_video !== "string" ? (
//                   <Typography variant="body2" color="primary">
//                     {formik.values?.Vehicle_video?.name}
//                   </Typography>
//                 ) : (
//                   <>
//                     {`Drop Video Here `}
//                     {formik?.touched?.Vehicle_video &&
//                     formik?.errors?.Vehicle_video ? (
//                       <FieldErrorText>
//                         {`(${formik.errors?.Vehicle_video})`}
//                       </FieldErrorText>
//                     ) : (
//                       ""
//                     )}
//                   </>
//                 )}
//               </Box>
//               <Button
//                 variant="contained"
//                 component="label"
//                 startIcon={<CloudUploadIcon />}
//                 sx={uploadButton}
//               >
//                 Browse Video
//                 <input
//                   type="file"
//                   hidden
//                   accept="video/*"
//                   onChange={handleVideoChange}
//                 />
//               </Button>
//             </Box>
//           </Box>

//           <Divider sx={{ marginBottom: "2rem" }} />

//           {formik?.touched?.images && formik?.errors?.images && (
//             <Box sx={{
//               ...errorContainer,
//               justifyContent: "flex-start"
//             }}>
//               <FieldErrorText>{formik?.errors?.images}</FieldErrorText>
//             </Box>
//           )}

//           <Box sx={{ marginBottom: "2rem" }}>
//             <Typography sx={sectionTitle}>Exterior Of The Car <span style={{ color: "red" }}>*</span></Typography>
//             <Grid container spacing={2} sx={imagesGridContainer}>
//               {formik?.values?.images?.["Exterior Of The Car"].map(
//                 (label, labelIdx) => {
//                   return (
//                     <Grid
//                       item
//                       key={`exterior-${labelIdx}`}
//                       sx={imageGridContainer}
//                     >
//                       <Box sx={imageInputContainer}>
//                         <input
//                           // ref={imagesInputsRef}
//                           type="file"
//                           accept="image/*"
//                           style={hiddenFileInput}
//                           onChange={(e) => {
//                             if (!e?.target?.files?.[0]) {
//                               return;
//                             }

//                             let images = formik?.values?.images?.[
//                               "Exterior Of The Car"
//                             ]?.map((item, itemIdx) => {
//                               if (itemIdx === labelIdx) {
//                                 return e?.target?.files?.[0];
//                               } else {
//                                 return item;
//                               }
//                             });
//                             formik.setValues((values) => {
//                               return {
//                                 ...values,
//                                 images: {
//                                   ...values?.images,
//                                   ["Exterior Of The Car"]: images,
//                                 },
//                               };
//                             });
//                             // imagesInputsRef.current.value = "";
//                           }}
//                         />
//                         {!label ? (
//                           <Box sx={addImageContent}>
//                             <AddPhotoAlternate sx={imagePlaceholderIcon} />
//                             <Typography sx={addImageText}>
//                               {exteriorLabels[labelIdx]}
//                             </Typography>
//                           </Box>
//                         ) : null}
//                       </Box>

//                       {!label ? (
//                         <Box
//                           sx={exampleImagesContainer}
//                         >
//                           <Tooltip
//                             arrow
//                             title={
//                               <ExampleImagesPopup
//                                 images={[
//                                   extImgEx1,
//                                   extImgEx2,
//                                   extImgEx3
//                                 ]}
//                               />
//                             }
//                             sx={{
//                               backgroundColor: `${theme.palette.background.paper} !important`,
//                             }}
//                             slotProps={{
//                               tooltip: {
//                                 sx: {
//                                   maxWidth: "none",
//                                 },
//                               },
//                               popper: {
//                                 sx: {
//                                   '& .MuiTooltip-tooltip': {
//                                     maxWidth: 'none', // For previous issue: ensure full width
//                                     whiteSpace: 'normal', // For previous issue: ensure text wraps

//                                     // 👇 Key changes for color:
//                                     backgroundColor: theme.palette.common.white, // Set your desired background color
//                                     color: theme.palette.text.primary, // Set your desired text color for content
//                                     boxShadow: `3px 3px 5px rgba(0, 0, 0, 0.5),
//                                       -1.5px -1.5px 5px rgba(0, 0, 0, 0.5)
//                                     `, // More subtle, common dark shadow
//                                   },
//                                   '& .MuiTooltip-arrow': {
//                                       color: theme.palette.common.white, // Match arrow color to tooltip background
//                                   }
//                                 },
//                               },
//                             }}
//                           >
//                             <InfoOutline
//                               sx={{
//                                 cursor: "pointer",
//                                 fill: `${theme.palette.text.disabled} !important`
//                               }}
//                             />
//                           </Tooltip>
//                         </Box>
//                       ) : null}

//                       {label ? (
//                         <ImageDeleteContainer
//                           imageList={"Exterior Of The Car"}
//                           formik={formik}
//                           idx={labelIdx}
//                         />
//                       ) : null}

//                       {label ? (
//                         <img
//                           src={
//                             typeof label === "string"
//                               ? label
//                               : URL.createObjectURL(label)
//                           }
//                           alt={label}
//                           style={imageStyle}
//                         />
//                       ) : null}
//                     </Grid>
//                   );
//                 }
//               )}
//             </Grid>
//           </Box>

//           <Box sx={{ marginBottom: "2rem" }}>
//             <Typography sx={sectionTitle}>Interior Of The Car <span style={{ color: "red" }}>*</span></Typography>
//             <Grid container spacing={2} sx={imagesGridContainer}>
//               {formik?.values?.images?.["Interior Of The Car"].map(
//                 (label, labelIdx) => {
//                   return (
//                     <Grid
//                       item
//                       key={`interior-${labelIdx}`}
//                       sx={imageGridContainer}
//                     >
//                       <Box sx={imageInputContainer}>
//                         <input
//                           // ref={imagesInputsRef}
//                           type="file"
//                           accept="image/*"
//                           style={hiddenFileInput}
//                           onChange={(e) => {
//                             if (!e?.target?.files?.[0]) {
//                               return;
//                             }

//                             let images = formik?.values?.images?.[
//                               "Interior Of The Car"
//                             ]?.map((item, itemIdx) => {
//                               if (itemIdx === labelIdx) {
//                                 return e?.target?.files?.[0];
//                               } else {
//                                 return item;
//                               }
//                             });
//                             formik.setValues((values) => {
//                               return {
//                                 ...values,
//                                 images: {
//                                   ...values?.images,
//                                   ["Interior Of The Car"]: images,
//                                 },
//                               };
//                             });

//                             // imagesInputsRef.current.value = "";
//                           }}
//                         />
//                         {!label ? (
//                           <Box sx={addImageContent}>
//                             <AddPhotoAlternate sx={imagePlaceholderIcon} />
//                             <Typography sx={addImageText}>
//                               {interiorLabels[labelIdx]}
//                             </Typography>
//                           </Box>
//                         ) : null}
//                       </Box>

//                       {!label ? (
//                         <Box
//                           sx={exampleImagesContainer}
//                         >
//                           <Tooltip
//                             arrow
//                             title={
//                               <ExampleImagesPopup
//                                 images={[
//                                   intImgEx1,
//                                   intImgEx2,
//                                   intImgEx3
//                                 ]}
//                               />
//                             }
//                             sx={{
//                               backgroundColor: `${theme.palette.background.paper} !important`,
//                             }}
//                             slotProps={{
//                               tooltip: {
//                                 sx: {
//                                   maxWidth: "none",
//                                 },
//                               },
//                               popper: {
//                                 sx: {
//                                   '& .MuiTooltip-tooltip': {
//                                     maxWidth: 'none', // For previous issue: ensure full width
//                                     whiteSpace: 'normal', // For previous issue: ensure text wraps

//                                     // 👇 Key changes for color:
//                                     backgroundColor: theme.palette.common.white, // Set your desired background color
//                                     color: theme.palette.text.primary, // Set your desired text color for content
//                                     boxShadow: `3px 3px 5px rgba(0, 0, 0, 0.5),
//                                       -1.5px -1.5px 5px rgba(0, 0, 0, 0.5)
//                                     `, // More subtle, common dark shadow
//                                   },
//                                   '& .MuiTooltip-arrow': {
//                                       color: theme.palette.common.white, // Match arrow color to tooltip background
//                                   }
//                                 },
//                               },
//                             }}
//                           >
//                             <InfoOutline
//                               sx={{
//                                 cursor: "pointer",
//                                 fill: `${theme.palette.text.disabled} !important`
//                               }}
//                             />
//                           </Tooltip>
//                         </Box>
//                       ) : null}

//                       {label ? (
//                         <ImageDeleteContainer
//                           imageList={"Interior Of The Car"}
//                           formik={formik}
//                           idx={labelIdx}
//                         />
//                       ) : null}

//                       {label ? (
//                         <img
//                           src={
//                             typeof label === "string"
//                               ? label
//                               : URL.createObjectURL(label)
//                           }
//                           alt={label}
//                           style={imageStyle}
//                         />
//                       ) : null}
//                     </Grid>
//                   );
//                 }
//               )}
//             </Grid>
//           </Box>

//           <Box sx={{ marginBottom: "2rem" }}>
//             <Typography sx={sectionTitle}>Rims Of The Car <span style={{ color: "red" }}>*</span></Typography>
//             <Grid container spacing={2} sx={imagesGridContainer}>
//               {formik?.values?.images?.["Rims Of The Car"].map(
//                 (label, labelIdx) => {
//                   return (
//                     <Grid item key={`rims-${labelIdx}`} sx={imageGridContainer}>
//                       <Box sx={imageInputContainer}>
//                         <input
//                           // ref={imagesInputsRef}
//                           type="file"
//                           accept="image/*"
//                           style={hiddenFileInput}
//                           onChange={(e) => {
//                             if (!e?.target?.files?.[0]) {
//                               return;
//                             }

//                             let images = formik?.values?.images?.[
//                               "Rims Of The Car"
//                             ]?.map((item, itemIdx) => {
//                               if (itemIdx === labelIdx) {
//                                 return e?.target?.files?.[0];
//                               } else {
//                                 return item;
//                               }
//                             });
//                             formik.setValues((values) => {
//                               return {
//                                 ...values,
//                                 images: {
//                                   ...values?.images,
//                                   ["Rims Of The Car"]: images,
//                                 },
//                               };
//                             });

//                             // imagesInputsRef.current.value = "";
//                           }}
//                         />
//                         {!label ? (
//                           <Box sx={addImageContent}>
//                             <AddPhotoAlternate sx={imagePlaceholderIcon} />
//                             <Typography sx={addImageText}>
//                               {rimsLabels[labelIdx]}
//                             </Typography>
//                           </Box>
//                         ) : null}
//                       </Box>

//                       {!label ? (
//                         <Box
//                           sx={exampleImagesContainer}
//                         >
//                           <Tooltip
//                             arrow
//                             title={
//                               <ExampleImagesPopup
//                                 images={[
//                                   rimsImgEx1,
//                                   rimsImgEx2,
//                                   rimsImgEx3
//                                 ]}
//                               />
//                             }
//                             sx={{
//                               backgroundColor: `${theme.palette.background.paper} !important`,
//                             }}
//                             slotProps={{
//                               tooltip: {
//                                 sx: {
//                                   maxWidth: "none",
//                                 },
//                               },
//                               popper: {
//                                 sx: {
//                                   '& .MuiTooltip-tooltip': {
//                                     maxWidth: 'none', // For previous issue: ensure full width
//                                     whiteSpace: 'normal', // For previous issue: ensure text wraps

//                                     // 👇 Key changes for color:
//                                     backgroundColor: theme.palette.common.white, // Set your desired background color
//                                     color: theme.palette.text.primary, // Set your desired text color for content
//                                     boxShadow: `3px 3px 5px rgba(0, 0, 0, 0.5),
//                                       -1.5px -1.5px 5px rgba(0, 0, 0, 0.5)
//                                     `, // More subtle, common dark shadow
//                                   },
//                                   '& .MuiTooltip-arrow': {
//                                       color: theme.palette.common.white, // Match arrow color to tooltip background
//                                   }
//                                 },
//                               },
//                             }}
//                           >
//                             <InfoOutline
//                               sx={{
//                                 cursor: "pointer",
//                                 fill: `${theme.palette.text.disabled} !important`
//                               }}
//                             />
//                           </Tooltip>
//                         </Box>
//                       ) : null}

//                       {label ? (
//                         <ImageDeleteContainer
//                           imageList={"Rims Of The Car"}
//                           formik={formik}
//                           idx={labelIdx}
//                         />
//                       ) : null}

//                       {label ? (
//                         <img
//                           src={
//                             typeof label === "string"
//                               ? label
//                               : URL.createObjectURL(label)
//                           }
//                           alt={label}
//                           style={imageStyle}
//                         />
//                       ) : null}
//                     </Grid>
//                   );
//                 }
//               )}
//             </Grid>
//           </Box>
//           <Box sx={{ marginBottom: "2rem" }}>
//             <Typography sx={sectionTitle}>Damage Photos <span style={{ color: "red" }}>*</span></Typography>
//             <Grid container spacing={2} sx={imagesGridContainer}>
//               {formik?.values?.images?.["Damage Photos"].map(
//                 (label, labelIdx) => {
//                   return (
//                     <Grid
//                       item
//                       key={`damage-${labelIdx}`}
//                       sx={imageGridContainer}
//                     >
//                       <Box sx={imageInputContainer}>
//                         <input
//                           // ref={imagesInputsRef}
//                           type="file"
//                           accept="image/*"
//                           style={hiddenFileInput}
//                           onChange={(e) => {
//                             if (!e?.target?.files?.[0]) {
//                               return;
//                             }

//                             let images = formik?.values?.images?.[
//                               "Damage Photos"
//                             ]?.map((item, itemIdx) => {
//                               if (itemIdx === labelIdx) {
//                                 return e?.target?.files?.[0];
//                               } else {
//                                 return item;
//                               }
//                             });
//                             formik.setValues((values) => {
//                               return {
//                                 ...values,
//                                 images: {
//                                   ...values?.images,
//                                   ["Damage Photos"]: images,
//                                 },
//                               };
//                             });

//                             // imagesInputsRef.current.value = "";
//                           }}
//                         />
//                         {!label ? (
//                           <Box sx={addImageContent}>
//                             <AddPhotoAlternate sx={imagePlaceholderIcon} />
//                             <Typography sx={addImageText}>
//                               Add Picture
//                             </Typography>
//                           </Box>
//                         ) : null}
//                       </Box>

//                       {label ? (
//                         <ImageDeleteContainer
//                           imageList={"Damage Photos"}
//                           formik={formik}
//                           idx={labelIdx}
//                         />
//                       ) : null}

//                       {label ? (
//                         <img
//                           src={
//                             typeof label === "string"
//                               ? label
//                               : URL.createObjectURL(label)
//                           }
//                           alt={label}
//                           style={imageStyle}
//                         />
//                       ) : null}
//                     </Grid>
//                   );
//                 }
//               )}
//             </Grid>
//           </Box>

//           {!isCarfaxPaymentDone || !generalInfoForm?.Carfax_Report_Url ? <Box sx={carfaxFullSection}>
//             {/* <div id="paypal-button-container" className="mt-4"></div> */}
//             <Typography variant="body1" sx={carfaxHeadline}>
//               Sell Faster with a Discounted Carfax Report
//             </Typography>

//             <Typography variant="body2" sx={carfaxSubHeadline}>
//               All carchaser.ca listings require a Carfax Vehicle History Report
//               to attract serious buyers. Pay just $65 for your report through us
//               and get your car sold quickly!
//             </Typography>

//             <Typography sx={carfaxDisclaimer}>
//               <span>Note:</span> A CARFAX report is essential for building trust
//               with potential dealers interested in buying your car. For a $65
//               fee, you’ll receive verified details about your car’s history,
//               including accident reports and any liens. By adding a CARFAX
//               report, you provide dealers with the information they need to make
//               an informed decision, increasing your chances of a successful
//               sale.
//             </Typography>

//             <Box sx={paypalButtonsGroup}>
//               <PayPalScriptProvider
//                 options={{
//                   'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
//                   currency: 'CAD'
//                 }}
//               >
//                 {/* Conditionally render buttons only when paypalOrderId is available */}
//                 {paypalOrderId && (
//                   <PayPalButtons
//                     style={{ layout: 'vertical', color: 'blue', shape: 'rect', label: 'paypal' }}
//                     createOrder={getPaypalOrderId} // Use the function that returns your pre-generated ID
//                     onApprove={async (data, actions) => {
//                       console.log(data, actions, `onApprove`);
//                       await onPaymentSuccessHandler(data, actions);
//                     }}
//                     onError={onPaymentErrorHandler}
//                     // You might also want to add onCancel for handling canceled payments
//                     onCancel={(data) => console.log('Payment cancelled:', data)}
//                   />
//                 )}
//                 {!paypalOrderId && <div>Generating PayPal order...</div>}
//               </PayPalScriptProvider>
//               {/* <div id="paypal-button-container" className="mt-4"></div> */}
//               {/* <button
//                 style={paypalButtonStyle}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   e.preventDefault();

//                   // handleCarfaxPayment();
//                 }}
//               >
//                 <img
//                   src="https://www.paypalobjects.com/webstatic/icon/pp258.png"
//                   alt="PayPal"
//                   width={24}
//                   height={24}
//                 />
//                 PayPal
//               </button>

//               <button style={cardButtonStyle}>
//                 <img
//                   src="https://img.icons8.com/ios-filled/50/2B52D2/bank-card-back-side.png"
//                   alt="Card"
//                   width={24}
//                   height={24}
//                 />
//                 Debit/Credit Card
//               </button> */}
//             </Box>
//           </Box> : null}

//           <Divider sx={{ marginBottom: "2rem" }} />

//           <NavigationButtons
//             isLoading={updateCarApiData?.isFetching}
//             previousFormHandler={previousFormHandler}
//           />
//         </form>
//       </Container>

//       {(!updateCarApiData?.isFetching && updateCarApiData?.isSuccess) ||
//       isSuccess ? (
//         <Modal
//           open={true}
//           onClose={() => {}}
//           aria-labelledby="vehicle-added-modal-title"
//           aria-describedby="vehicle-added-modal-description"
//         >
//           <VehicleAddedModal handleClose={onSuccessCallback}
//             isEditing={isEditing}
//           />
//         </Modal>
//       ) : null}
//       <ViewVideoModal
//         open={openViewVideoModal}
//         onClose={() => setOpenViewVideoModal(false)}
//         video={formik.values.Vehicle_video}
//       />

//       {/* {carfaxReportUrl ? (
//         <Modal
//           open={true}
//           onClose={() => {}}
//           aria-labelledby="carfax-report-title"
//           aria-describedby="carfax-report-description"
//         >
//           <PdfViewer
//             pdfUrl={carfaxReportUrl}
//           />
//         </Modal>
//       ) : null} */}
//     </>
//   );
// };

// export default Gallery;

import {
  CancelTwoTone,
  CloudUpload as CloudUploadIcon,
  InfoOutline,
  Edit
} from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Modal,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useFormik } from 'formik';
import lodash from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import checkmarkIcon from '../../../../components/assets/checkmark-circle.svg';
import extImgEx1 from '../../../../components/assets/ext-img-ex1.svg';
import extImgEx2 from '../../../../components/assets/ext-img-ex2.svg';
import extImgEx3 from '../../../../components/assets/ext-img-ex3.svg';
import imagePlaceholderIcon from '../../../../components/assets/image_placeholder.svg';
import intImgEx1 from '../../../../components/assets/int1.avif';
import intImgEx2 from '../../../../components/assets/int2.avif';
import intImgEx3 from '../../../../components/assets/int3.avif';
import CarfaxLogo from '../../../../components/assets/logos/Carfax-Logo.png';
import backseatSide1 from '../../../../components/assets/my-garage/gallery/back-seat1.jpeg';
import backseatSide2 from '../../../../components/assets/my-garage/gallery/back-seat2.jpeg';
import backseatSide3 from '../../../../components/assets/my-garage/gallery/back-seat3.jpg';
import consoleSide1 from '../../../../components/assets/my-garage/gallery/console-1.jpeg';
import consoleSide2 from '../../../../components/assets/my-garage/gallery/console-2.jpeg';
import consoleSide3 from '../../../../components/assets/my-garage/gallery/console-3.jpeg';
import driverSide1 from '../../../../components/assets/my-garage/gallery/driver-side1.webp';
import driverSide2 from '../../../../components/assets/my-garage/gallery/driver-side2.jpeg';
import driverSide3 from '../../../../components/assets/my-garage/gallery/driver-side3.jpg';
import passengerSide1 from '../../../../components/assets/my-garage/gallery/passenger-side1.webp';
import passengerSide2 from '../../../../components/assets/my-garage/gallery/passenger-side2.jpeg';
import passengerSide3 from '../../../../components/assets/my-garage/gallery/passenger-side3.jpeg';
import rearSide1 from '../../../../components/assets/my-garage/gallery/rear-side1.jpeg';
import rearSide2 from '../../../../components/assets/my-garage/gallery/rear-side2.jpeg';
import rearSide3 from '../../../../components/assets/my-garage/gallery/rear-side3.avif';
import steeringSide1 from '../../../../components/assets/my-garage/gallery/steering-1.jpeg';
import steeringSide2 from '../../../../components/assets/my-garage/gallery/steering-2.jpeg';
import steeringSide3 from '../../../../components/assets/my-garage/gallery/steering-3.jpeg';
import rimsImgEx1 from '../../../../components/assets/rims1.avif';
import rimsImgEx2 from '../../../../components/assets/rims2.avif';
import rimsImgEx3 from '../../../../components/assets/rims3.avif';
import videoIcon from '../../../../components/assets/video.svg';
import ViewVideoModal from '../../../../components/custom/ViewVideoModal';
import FieldErrorText from '../../../../components/ui/FieldErrorText';
import theme from '../../../../theme';
import { setAlertDialog } from '../../../../toolkit/alertDialog/alertDialogSlice';
import { useLazyGetVehicleDetailsQuery } from '../../../../toolkit/carDetails/carDetailsApi';
import { useCompleteCarfaxPaymentMutation, useLazyGetCarfaxReportQuery } from '../../../../toolkit/carfax/carfaxApi';
import { useLazyUpdateCarQuery, useUpdateCarOnRelistPendingMutation } from '../../../../toolkit/myGarage/myGarageApi';
import { setGalleryForm } from '../../../../toolkit/myGarage/myGarageSlice';
import { useCreatePaypalOrderMutation } from '../../../../toolkit/paypal/paypalApi';
import { CAR_STATUS } from '../../../../utils/constants/carData';
import { isVehicleDataEditEnabled } from '../../../../utils/methods/generalVehicleMethods';
import { isLinkRegex } from '../../../../utils/regex/isLinkRegex';
import NavigationButtons from '../NavigationButtons';
import { useCarfaxReportPaymentHandler } from './customHooks/useCarfaxReportPaymentHandler';
import DamagePhotosModal from './DamagePhotosModal';
import ExampleImagesPopup from './ExampleImagesPopup';
import {
  addImageContent,
  addImageText,
  carfaxDisclaimer,
  carfaxFullSection,
  carfaxHeadline,
  carfaxSubHeadline,
  exampleImagesContainer,
  hiddenFileInput,
  imageGridContainer,
  imageIndividualImageGridContainer,
  imageInputContainer,
  imagesGridContainer,
  imageStyle,
  mainContainere,
  paperContainer,
  paypalButtonsGroup,
  sectionTitle,
  subtitleText,
  uploadButton,
  videoUploadContainer
} from './GallerySx';
import { errorContainer } from './QuestionareSx';
import VehicleAddedModal from './VehicleAddedSuccessModal';
import { getShortenedString } from "../../../../utils/methods/stringMethods";

const ImageDeleteContainer = ({ imageList, formik, idx }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0',
        right: '0',
        zIndex: '20',
      }}
    >
      <Button
        sx={{
          padding: '0',
          minWidth: '0',
        }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();

          formik.setValues((values) => {
            return {
              ...values,
              images: {
                ...values?.images,
                [imageList]: values?.images?.[imageList]?.map?.((item, itemIdx) => {
                  if (itemIdx === idx) {
                    return '';
                  } else {
                    return item;
                  }
                }),
              },
            };
          });
        }}
      >
        <CancelTwoTone
          sx={{
            color: theme.palette.text.primary,
          }}
        />
      </Button>
    </Box>
  );
};

const Gallery = ({ changeTabHandler, onSuccessCallback, previousFormHandler }) => {

  const parentRef = React.useRef(null);
  const gridRef = React.useRef(null);

  const { t } = useTranslation('gallery');

  // Translation arrays
  const exteriorLabels = [
    t('exteriorLabels.front'),
    t('exteriorLabels.driverSide'),
    t('exteriorLabels.passengerSide'),
    t('exteriorLabels.back'),
  ];

  const interiorLabels = [
    t('interiorLabels.dashboard'),
    t('interiorLabels.console'),
    t('interiorLabels.steeringWheel'),
    t('interiorLabels.backSeat'),
  ];

  const rimsLabels = [
    t('rimsLabels.frontLeft'),
    t('rimsLabels.frontRight'),
    t('rimsLabels.rearLeft'),
    t('rimsLabels.rearRight'),
  ];

  const damageLabels = [
    t('damageLabels.damage1'),
    t('damageLabels.damage2'),
    t('damageLabels.damage3'),
    t('damageLabels.damage4'),
  ];

  // useRef start...
  const imagesInputsRef = React.useRef({
    interior: ['', '', '', ''],
    exterior: ['', '', '', ''],
    rims: ['', '', '', ''],
    other: ['', '', '', ''],
    damage: ['', '', '', ''],
  });

  const onMountRef = React.useRef({
    images: false,
    setGalleryForm: false,
  });
  // useRef end...

  // useMemo start...
  const damagePhotosModalInit = React.useMemo(() => {
    return {
      open: false,
      isEditingDesc: false,
      idx: null,
      description: '',
      image: null,
    };
  }, []);

  const dispatch = useDispatch();
  const auth = useSelector((store) => store.auth);
  const { forms, previouslySubmittedForms, vehicle_id, isEditing } = useSelector(
    (store) => store.myGarage
  );

  const generalInfoForm = forms?.generalInfo;
  const questionareForm = forms?.questionare;
  const specificationsForm = forms?.specifications;
  const galleryForm = forms?.gallery;

  const [updateCarApiHandler, updateCarApiData] = useLazyUpdateCarQuery();
  const [createPaypalOrderApiHandler, createPaypalOrderApiData] = useCreatePaypalOrderMutation();
  const [completeCarfaxPaymentApiHandler, completeCarfaxPaymentApiData] = useCompleteCarfaxPaymentMutation();
  const [getCarfaxReportApiHandler, getCarfaxReportApiData] = useLazyGetCarfaxReportQuery();
  const [updateCarOnRelistPendingApiHandler, updateCarOnRelistPendingApiData] = useUpdateCarOnRelistPendingMutation();
  const [getVehicleDetailsApiHandler, getVehicleDetailsApiData] = useLazyGetVehicleDetailsQuery();

  const validationSchema = Yup.object({
    // imagesDescription: Yup.object().shape({
    //   "Exterior Of The Car": Yup.array(),
    //   "Interior Of The Car": Yup.array(),
    //   "Rims Of The Car": Yup.array(),
    //   // "Other Pictures": Yup.array(),
    //   "Damage Photos": Yup.array(),
    // }),
    images: Yup.object()
      .shape({
        'Exterior Of The Car': Yup.array(),
        'Interior Of The Car': Yup.array(),
        'Rims Of The Car': Yup.array(),
        // "Other Pictures": Yup.array(),
        'Damage Photos': Yup.array(),
      })
      .test(
        'all-image-arrays-not-empty', // Name of the test
        t('validationMessages.imageRequired'), // Translated error message
        function (imagesObj) {
          // `imagesObj` here is the value of the `images` object being validated.
          // It will be something like:
          // {
          //   "Exterior Of The Car": ["url1", "", "url2", ""],
          //   "Interior Of The Car": ["url3", "", "", ""],
          //   // ... and so on
          // }

          if (!imagesObj) {
            // If the images object itself is null or undefined, consider it invalid.
            return false;
          }

          // Get all the keys (category names) from the images object
          const categories = Object.keys(imagesObj);
          
          // Iterate over each category and check its corresponding array
          const allCategoriesHaveAtLeastOneImage = categories.every((categoryName) => {
            const imageArray = imagesObj[categoryName];

            // Ensure it's an array and contains at least one non-empty string

            if (selectedVehicle?.Ext_Mint_Condition === 1 && selectedVehicle?.Int_Mint_Condition === 1 &&
              categoryName === "Damage Photos"
            ) {
              return true;
            }

            return Array.isArray(imageArray) && imageArray.some((str) => str);
          });

          console.log(imagesObj, `imagesObj`);

          // If any category fails the check, this overall test fails.
          if (!allCategoriesHaveAtLeastOneImage) {
            // You can use `this.createError` for more granular error messages if needed,
            // but for a single message for the entire object, returning false is fine.
            return this.createError({
              path: this.path, // Path to the 'images' object
              message: t('validationMessages.imageRequired'),
            });
          }

          return true; // All checks passed
        }
      ),
    notes: Yup.object().shape({
      'Damage Photos': Yup.array()
        // We still define the array structure but remove the 'required' and 'min(1)' from `.of()`
        .of(Yup.string().nullable().optional())
        // Keep the length constraints (assuming the array length is fixed at 4)
    }),
    Damage_Multiple_Label: Yup.string(),
    Vehicle_video: Yup.mixed().optional().nullable(),
    // .required(t("validationMessages.videoRequired")),
  })
    .test(
      'root-conditional-note-required',
      'Note is required for uploaded damage photos!',
      function (data) {
        // 'data' here is the entire top-level object: { images: {...}, notes: {...}, Vehicle_video: null }

        const damageImages = data.images?.['Damage Photos'] || [];
        const notesArray = data.notes?.['Damage Photos'] || [];

        // Ensure both arrays are the expected size (4) before proceeding
        if (damageImages.length !== 4 || notesArray.length !== 4) {
          // This case should theoretically be caught by the .min(4)/.max(4) tests above,
          // but it's a safe guard.
          return true;
        }

        // Iterate over the arrays
        for (let i = 0; i < 4; i++) {
          const imageValue = damageImages[i];
          const noteValue = notesArray[i];

          // Check if the image exists (is truthy and non-empty string)
          const imageExists = Boolean(imageValue);

          // Check if the note is empty (falsy or empty/whitespace string)
          const noteIsEmpty = !noteValue || String(noteValue).trim() === '';

          // If Image exists AND Note is empty, fail validation
          if (imageExists && noteIsEmpty) {
            // IMPORTANT: The path must be absolute from the root object.
            return this.createError({
              path: `notes.Damage Photos[${i}]`,
              message: "Note is required for this damage photo.",
            });
          }
        }

        return true;
      }
    )
    // .test(
    //   'damage-label-conditional-required',
    //   'Damage label is required for the fifth damage photo.',
    //   function (data) {
    //     const damagePhotos = data.images?.['Damage Photos'] || [];
    //     const damageLabel = data.Damage_Multiple_Label;
        
    //     // The condition is: 
    //     // 1. images.Damage Photos length must be 5.
    //     // 2. The 5th element (index 4) must be truthy (image uploaded).
        
    //     const isFifthImageRequired = damagePhotos.length === 5 && damagePhotos[4];

    //     if (isFifthImageRequired) {
    //       // If the 5th image exists, the Damage_Multiple_Label must be truthy (required)
    //       const labelIsMissing = !damageLabel || String(damageLabel).trim() === '';
          
    //       if (labelIsMissing) {
    //         // Fail validation and create error pointing specifically to Damage_Multiple_Label
    //         return this.createError({
    //           path: 'Damage_Multiple_Label',
    //           message: 'Note is required for this damage photo.',
    //         });
    //       }
    //     }

    //     return true; // Validation passes (either the condition wasn't met, or the label was provided)
    //   }
    // )
    ;

  const initialValues = {
    // imagesDescription: {
    //   "Exterior Of The Car":[],
    //   "Interior Of The Car":[],
    //   "Rims Of The Car":[],
    //   // "Other Pictures":[],
    //   "Damage Photos":[],
    // },
    images: {
      'Exterior Of The Car': ['', '', '', ''] /*[]*/,
      'Interior Of The Car': ['', '', '', ''] /*[]*/,
      'Rims Of The Car': ['', '', '', ''] /*[]*/,
      // "Other Pictures": ["", "", "", ""] /*[]*/,
      'Damage Photos': ['', '', '', ''] /*[]*/,
    },
    notes: {
      'Damage Photos': ['', '', '', ''] /*[]*/,
    },
    Damage_Multiple_Label: "",
    Vehicle_video: null,
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const payload = {};

      // for (let i = 0; i < Object.entries(emptyFieldsPartialForm)?.length; i++) {
      //   payload[[Object.entries(emptyFieldsPartialForm)?.[i]?.[0]]] =
      //     Object.entries(emptyFieldsPartialForm)?.[i]?.[1];
      // }

      // const formData = new FormData();
      for (let i = 0; i < 4; i++) {
        if (typeof values?.images?.['Interior Of The Car']?.[i] !== 'string') {
          // const fileName = values?.images?.["Interior Of The Car"]?.[
          //   i
          // ].substring(
          //   values?.images?.["Interior Of The Car"]?.[i].lastIndexOf("/") + 1
          // );
          // payload[`Interior_Image${i + 1}`] = fileName;
          // // formData.append(`Interior_Image${i + 1}`, fileName);

          payload[`Interior_Image${i + 1}`] = values?.images?.['Interior Of The Car']?.[i];
        } else if (values?.images?.['Interior Of The Car']?.[i] === '') {
          payload[`Interior_Image${i + 1}`] = values?.images?.['Interior Of The Car']?.[i];
          // formData.append(`Interior_Image${i + 1}`, values?.images?.["Interior Of The Car"]?.[i]);
        }
      }


      let interior_existing_images = "";
      for (let i = 4; i < values?.images?.['Interior Of The Car']?.length; i++) {
        if (typeof values?.images?.['Interior Of The Car']?.[i] !== "string") {
          payload[`interior_images[${i-4}]`] = values?.images?.['Interior Of The Car']?.[i];
        } else {
          const lastSlashIndex = values?.images?.['Interior Of The Car']?.[i]?.lastIndexOf?.('/');
          const imageName = values?.images?.['Interior Of The Car']?.[i]?.substring?.(lastSlashIndex + 1);
          interior_existing_images += imageName + ",";
        }
      }

      if (interior_existing_images) {
        payload[`interior_existing_images`] = interior_existing_images?.trim?.()?.slice?.(0, -1);
      }

      for (let i = 0; i < 4; i++) {
        if (typeof values?.images?.['Exterior Of The Car']?.[i] !== 'string') {
          // const fileName = values?.images?.["Exterior Of The Car"]?.[
          //   i
          // ].substring(
          //   values?.images?.["Exterior Of The Car"]?.[i].lastIndexOf("/") + 1
          // );
          // payload[`Exterior_Image${i + 1}`] = fileName;
          // // formData.append(`Exterior_Image${i + 1}`, fileName);

          payload[`Exterior_Image${i + 1}`] = values?.images?.['Exterior Of The Car']?.[i];
        } else if (values?.images?.['Exterior Of The Car']?.[i] === '') {
          payload[`Exterior_Image${i + 1}`] = values?.images?.['Exterior Of The Car']?.[i];
          // formData.append(`Exterior_Image${i + 1}`, values?.images?.["Exterior Of The Car"]?.[i]);
        }
      }

      let exterior_existing_images = "";
      for (let i = 4; i < values?.images?.['Exterior Of The Car']?.length; i++) {
        if (typeof values?.images?.['Exterior Of The Car']?.[i] !== "string") {
          payload[`exterior_images[${i-4}]`] = values?.images?.['Exterior Of The Car']?.[i];
        } else {
          const lastSlashIndex = values?.images?.['Exterior Of The Car']?.[i]?.lastIndexOf?.('/');
          const imageName = values?.images?.['Exterior Of The Car']?.[i]?.substring?.(lastSlashIndex + 1);
          exterior_existing_images += imageName + ",";
        }
      }

      if (exterior_existing_images) {
        payload[`exterior_existing_images`] = exterior_existing_images?.trim?.()?.slice?.(0, -1);
      }

      for (let i = 0; i < 4; i++) {
        if (typeof values?.images?.['Rims Of The Car']?.[i] !== 'string') {
          // const fileName = values?.images?.["Rims Of The Car"]?.[i].substring(
          //   values?.images?.["Rims Of The Car"]?.[i].lastIndexOf("/") + 1
          // );
          // payload[`Rims_Image${i + 1}`] = fileName;
          // // formData.append(`Rims_Image${i + 1}`, fileName);

          payload[`Rims_Image${i + 1}`] = values?.images?.['Rims Of The Car']?.[i];
        } else if (values?.images?.['Rims Of The Car']?.[i] === '') {
          payload[`Rims_Image${i + 1}`] = values?.images?.['Rims Of The Car']?.[i];
          // formData.append(`Rims_Image${i + 1}`, values?.images?.["Rims Of The Car"]?.[i]);
        }
      }

      let rims_existing_images = "";
      for (let i = 4; i < values?.images?.['Rims Of The Car']?.length; i++) {
        if (typeof values?.images?.['Rims Of The Car']?.[i] !== "string") {
          payload[`rims_images[${i-4}]`] = values?.images?.['Rims Of The Car']?.[i];
        } else {
          const lastSlashIndex = values?.images?.['Rims Of The Car']?.[i]?.lastIndexOf?.('/');
          const imageName = values?.images?.['Rims Of The Car']?.[i]?.substring?.(lastSlashIndex + 1);
          rims_existing_images += imageName + ",";
        }
      }

      if (rims_existing_images) {
        payload[`rims_existing_images`] = rims_existing_images?.trim?.()?.slice?.(0, -1);
      }

      for (let i = 0; i < 4; i++) {
        if (typeof values?.images?.['Damage Photos']?.[i] !== 'string') {
          // const fileName = values?.images?.["Damage Photos"]?.[i].substring(
          //   values?.images?.["Damage Photos"]?.[i].lastIndexOf("/") + 1
          // );
          // payload[`Dashboard_Image${i + 1}`] = fileName;
          // // formData.append(`Dashboard_Image${i + 1}`, fileName);

          payload[`Dashboard_Image${i + 1}`] = values?.images?.['Damage Photos']?.[i];
        } else if (values?.images?.['Damage Photos']?.[i] === '') {
          payload[`Dashboard_Image${i + 1}`] = values?.images?.['Damage Photos']?.[i];
          // formData.append(`Dashboard_Image${i + 1}`, values?.images?.["Damage Photos"]?.[i]);
        }
      }

      let damage_existing_images = "";
      for (let i = 4; i < values?.images?.['Damage Photos']?.length; i++) {
        if (typeof values?.images?.['Damage Photos']?.[i] !== "string") {
          payload[`damage_images[${i-4}]`] = values?.images?.['Damage Photos']?.[i];
        } else {
          const lastSlashIndex = values?.images?.['Damage Photos']?.[i]?.lastIndexOf?.('/');
          const imageName = values?.images?.['Damage Photos']?.[i]?.substring?.(lastSlashIndex + 1);
          damage_existing_images += imageName + ",";
        }
      }

      if (damage_existing_images) {
        payload[`damage_existing_images`] = damage_existing_images?.trim?.()?.slice?.(0, -1);
      }

      for (let i = 0; i < 4; i++) {
        if (values?.notes?.["Damage Photos"]?.[i]) {
          payload[`damage_label_${i + 1}`] = values?.notes?.['Damage Photos']?.[i];
        }
      }

      payload[`Damage_Multiple_Label`] = "";
      for (let i = 4; i < values?.notes?.['Damage Photos']?.length; i++) {
        if (i === values?.notes?.['Damage Photos']?.length - 1) {
          payload[`Damage_Multiple_Label`] += values?.notes?.['Damage Photos']?.[i];
        } else {
          payload[`Damage_Multiple_Label`] += values?.notes?.['Damage Photos']?.[i] + ",";
        }
      }

      if (payload[`Damage_Multiple_Label`]?.endsWith?.(",")) {
        // If it does, return a new string with the last two characters removed
        payload[`Damage_Multiple_Label`] = payload[`Damage_Multiple_Label`]?.slice?.(0, -1);
      }

      // for (let i = 0; i < values?.notes?.["Damage Photos"]?.length; i++) {
      //   payload[`Damage_Label_${i + 1}`] = values?.notes?.["Damage Photos"]?.[i];
      // }

      if (typeof values?.Vehicle_video !== 'string') {
        payload[`Vehicle_video`] = values?.Vehicle_video;
      } else if (values?.Vehicle_video === '') {
        payload[`Vehicle_video`] = values?.Vehicle_video;
      }

      // STEP4 end

      const formData = new FormData();

      for (let i = 0; i < Object.entries(payload).length; i++) {
        formData.append(Object.entries(payload)?.[i]?.[0], Object.entries(payload)?.[i]?.[1]);
      }

      formData.append(`Seller_Id`, auth?.user_id);

      const editMode = 'normaledit';

      console.log(previouslySubmittedForms?.gallery, formik?.values, `previouslySubmittedForms`);

      if (!lodash?.isEqual(previouslySubmittedForms?.gallery, formik?.values)) {
        let response;

        if (getVehicleDetailsApiData?.data?.vehicle?.car_label_status === CAR_STATUS.RELIST_PENDING) {
          response = await updateCarOnRelistPendingApiHandler({
            formData,
            Vehicle_Id: vehicle_id,
          });
        } else {
          response = await updateCarApiHandler({
            formData,
            endpoint: `/updatevehicle/${vehicle_id}/${editMode}`,
          });
        }

        if ('status' in (response?.data || {}) && !response?.data?.status) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error!`,
              message: response?.error?.message || t('errors.someErrorOccurred'),
            })
          );
        } else if ('status' in (response?.data || {}) && response?.data?.status) {
          setIsSuccess(true);
        }
      } else {
        setIsSuccess(true);
      }
    },
  });

  // useState variables start...
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [openViewVideoModal, setOpenViewVideoModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = React.useState(null);
  const [paypalOrderId, setPaypalOrderId] = React.useState(null);
  const [isCarfaxPaymentInProgress, setIsCarfaxPaymentInProgress] = React.useState(false);
  const [isCarfaxPaymentDone, setIsCarfaxPaymentDone] = React.useState(false);
  const [carfaxReportUrl, setCarfaxReportUrl] = React.useState('');
  const [damagePhotosModal, setDamagePhotosModal] = React.useState(damagePhotosModalInit);
  const [parentWidth, setParentWidth] = React.useState(0);
  // useState variables end...

  // Handlers start...
  const handleVideoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      formik.setFieldValue('Vehicle_video', file);
    }
  };

  // const handleCarfaxPayment = async () => {
  //   const storedVehicleId = vehicle_id;
  //   const script = document.createElement("script");
  //   script.src = `https://www.paypal.com/sdk/js?client-id=AUJsTBrdpNk9-KgCgsf9KvoCQhYUE2lWgclrEj-4B2qt8jwijj9LdvTeKuJWRjwRxNSbUSIiKDoesg0x&currency=CAD&locale=en_CA`;
  //   script.async = true;

  //   const loadPayPalButton = () => {
  //     if (window.paypal) {
  //       document.getElementById("paypal-button-container").innerHTML = "";

  //       window.paypal
  //         .Buttons({
  //           createOrder: (data, actions) => {
  //             return actions.order.create({
  //               purchase_units: [
  //                 {
  //                   amount: { value: "67" }, // Replace with your amount
  //                   custom_id: auth?.user_id, // <<< ADD THIS LINE TO SEND USER_ID
  //                 },
  //               ],
  //               application_context: {
  //                 shipping_preference: "NO_SHIPPING",
  //                 user_action: "PAY_NOW",
  //               },
  //             });
  //           },
  //           onApprove: (data, actions) => {
  //             return actions.order.capture().then((details) => {
  //               // setSuccessMessageCarFaxReport(
  //               //   `Transaction completed by ${details.payer.name.given_name}`
  //               // );
  //               // setTransactionComplete(true);

  //               // Call API after transaction completion
  //               const fetchCarfaxElvalutionApi = async () => {
  //                 try {
  //                   const carfaxResponse = await api.get(
  //                     `/seller/carfaxevalvationreport/${storedVehicleId}/${generalInfoForm?.VIN}/0`
  //                   );

  //                   const vehicleResponse = await api.get(
  //                     `/seller/vehicle/${storedVehicleId}`
  //                   );
  //                   const vehicleData = vehicleResponse.data;

  //                   // setCarFaxUrl(vehicleData.vehicle.Carfax_Report_Url);
  //                 } catch (error) {
  //                   console.error("Carfax Report: Error fetching url:", error);
  //                 }
  //               };

  //               fetchCarfaxElvalutionApi();
  //             });
  //           },
  //           onError: (err) => {
  //             console.error("PayPal Checkout onError", err);
  //             alert(
  //               "An error occurred during the transaction. Please try again."
  //             );
  //           },
  //         })
  //         .render("#paypal-button-container");
  //     }
  //   };

  //   script.onload = loadPayPalButton;
  //   document.body.appendChild(script);
  // };

  const createPaypalOrder = async () => {
    const res = await createPaypalOrderApiHandler({
      payload: {
        amount: '67',
        currency: 'CAD',
        vehicle_id: vehicle_id,
      },
    });

    if (res?.error || ('status' in res?.data && !res?.data?.status)) {
      dispatch(
        setAlertDialog({
          open: true,
          title: `Error!`,
          message:
            res?.error?.data?.error || res?.error?.data?.message || res?.data?.message || t('errors.someErrorOccurred'),
        })
      );
      return;
    } else {
      setPaypalOrderId(res?.data?.paypal_order_id);
      return res?.data?.paypal_order_id;
    }
  };

  const onPaymentStatusHandler = (data) => {
    setIsCarfaxPaymentInProgress(false);
  };

  const onPaymentSuccessHandler = async (data, actions) => {
    dispatch(
      setAlertDialog({
        open: true,
        title: `Success!`,
        message: `The payment was successful. Fetching your Carfax report now.`,
      })
    );

    const res = await getCarfaxReportApiHandler({
      Vehicle_Id: vehicle_id,
      vin: generalInfoForm?.VIN,
    });

    setCarfaxReportUrl(res?.data?.Url || '');

    setIsCarfaxPaymentDone(true);
  };

  const onPaymentProcessingHandler = async (data, actions) => {
    console.log(data, actions, `onPaymentProcessingHandler`);

    if (!data?.orderID) {
      dispatch(
        setAlertDialog({
          open: true,
          title: `Error!`,
          message: t('errors.paymentOrderIdNotFound'),
        })
      );
      return;
    }

    setIsCarfaxPaymentInProgress(true);
    dispatch(
      setAlertDialog({
        open: true,
        title: `Processing`,
        message: `Please wait on this page while we are processing your payment. We'll notify you once it's done.`,
      })
    );
  };

  const onPaymentErrorHandler = (err) => {
    console.error('PayPal Checkout error:', err);
    dispatch(
      setAlertDialog({
        open: true,
        title: `Error!`,
        message: err?.message || t('errors.paypalCheckoutError'),
      })
    );
  };

  const getCarfaxReportHandler = async () => {
    const res = await getCarfaxReportApiHandler({
      Vehicle_Id: vehicle_id,
      vin: generalInfoForm?.VIN,
    });

    if (res?.isError || ('status' in res?.data && !res?.data?.status)) {
      dispatch(
        setAlertDialog({
          open: true,
          title: `Error!`,
          message:
            res?.error?.data?.error || res?.error?.data?.message || res?.data?.message || t('errors.someErrorOccurred'),
        })
      );
    } else {
      setCarfaxReportUrl(res?.data?.Url || '');
      window.open(res?.data?.Url, '_blank');
    }
  };

  const onChangeDamagePhotosHandler = (img, description, idx) => {
    let images = formik?.values?.images?.['Damage Photos']?.map((item, itemIdx) => {
      if (itemIdx === idx) {
        return img;
      } else {
        return item;
      }
    });

    // let damagePhotosLabelArr
    // let updatedDamage_Multiple_Label;
    // let notes;

    // if (idx > 3) {
    //   damagePhotosLabelArr = formik?.values?.Damage_Multiple_Label ? formik?.values?.Damage_Multiple_Label?.split(", ") : [];
    //   if (damagePhotosLabelArr?.length + 4 >= idx + 1) {
    //     damagePhotosLabelArr[idx - 4] = description;
    //   } else {
    //     damagePhotosLabelArr.push(description);
    //   }
    //   updatedDamage_Multiple_Label = damagePhotosLabelArr?.length > 1 ? damagePhotosLabelArr.join(", ") : damagePhotosLabelArr?.join("");
    // } else {
    //   notes = {
    //     ...(formik?.values?.notes || {}),
    //     "Damage Photos": formik?.values?.notes?.['Damage Photos']?.map((item, itemIdx) => {
    //       if (itemIdx === idx) {
    //         return description;
    //       } else {
    //         return item;
    //       }
    //     })
    //   };
    // }

    // console.log(updatedDamage_Multiple_Label, damagePhotosLabelArr, formik?.values?.Damage_Multiple_Label, "updatedDamage_Multiple_Label")

    formik.setValues((values) => {
      return {
        ...values,
        notes: {
          ...values?.notes,
          ["Damage Photos"]: values?.notes?.['Damage Photos']?.map((damagePhotosNote, damagePhotosNoteIdx) => {
            if (damagePhotosNoteIdx === idx) {
              return description;
            } else return damagePhotosNote;
          })
        },
        // Damage_Multiple_Label: updatedDamage_Multiple_Label || values?.Damage_Multiple_Label,
        images:
          img === null
            ? values?.images
            : {
              ...values?.images,
              ['Damage Photos']: images,
            },
      };
    });
  };

  useCarfaxReportPaymentHandler({
    orderId: paypalOrderId,
    onPaymentCompletedHandler: onPaymentSuccessHandler,
    onPaymentStatusHandler,
  });
  // Handlers end...

  // useEffect start...
  // React.useEffect(() => {
  //   (async () => {
  //     try {
  //       const response = await api.get(
  //         `/seller/getvehicleimages/${vehicle_id}`damagePhotosLabelArr
  //       );

  //       const dashboardImages = response?.data?.Vehicle_Image?.[0]?.dashboard;
  //       const exteriorImages = response?.data?.Vehicle_Image?.[0]?.exterior;
  //       const interiorImages = response?.data?.Vehicle_Image?.[0]?.interior;
  //       const rimsImages = response?.data?.Vehicle_Image?.[0]?.rims;

  //       const mixBaseDashboardImages = [];
  //       dashboardImages.forEach((image) => {
  //         if (image !== null) {
  //           mixBaseDashboardImages.push(
  //             baseImageUrl + `${vehicle_id}/` + image
  //           );
  //         }
  //       });
  //       const mixBaseExteriorImages = [];
  //       exteriorImages.forEach((image) => {
  //         if (image !== null) {
  //           mixBaseExteriorImages.push(baseImageUrl + `${vehicle_id}/` + image);
  //         }
  //       });
  //       const mixBaseInteriorImages = [];
  //       interiorImages.forEach((image) => {
  //         if (image !== null) {
  //           mixBaseInteriorImages.push(baseImageUrl + `${vehicle_id}/` + image);
  //         }
  //       });
  //       const mixBaseRimsImages = [];
  //       rimsImages.forEach((image) => {
  //         if (image !== null) {
  //           mixBaseRimsImages.push(baseImageUrl + `${vehicle_id}/` + image);
  //         }
  //       });

  //       formik.setValues((values) => {
  //         return {
  //           ...values,
  //           images: {
  //             ...values?.images,
  //             ["Interior Of The Car"]: mixBaseInteriorImages,
  //             ["Exterior Of The Car"]: mixBaseExteriorImages,
  //             ["Rims Of The Car"]: mixBaseRimsImages,
  //             ["Damage Photos"]: mixBaseDashboardImages,
  //             ["Other Pictures"]: [],
  //           },
  //         };
  //       });
  //     } catch (err) {
  //       //
  //     }
  //   })();
  // }, []);

  React.useEffect(() => {
    if (galleryForm) {
      formik.setValues((values) => {
        return {
          ...values,
          ...galleryForm,
        };
      });
    }
  }, []);

  React.useEffect(() => {
    if (onMountRef.current.setGalleryForm) {
      dispatch(setGalleryForm(formik?.values));
    } else {
      onMountRef.current.setGalleryForm = true;
    }
  }, [formik?.values]);

  React.useEffect(() => {
    if (
      (updateCarApiData?.isSuccess && !updateCarApiData?.isFetching) ||
      (updateCarOnRelistPendingApiData?.isSuccess && !updateCarOnRelistPendingApiData?.isLoading)
    ) {
      setIsSuccess(true);
    }
  }, [updateCarApiData?.isSuccess, updateCarOnRelistPendingApiData?.isSuccess]);

  // React.useEffect(() => {
  //   if (!isCarfaxPaymentDone && !generalInfoForm?.Carfax_Report_Url) {
  //     createPaypalOrder();
  //   }
  // }, []);

  // React.useEffect(() => {
  //   if (onMountRef.current?.images) {
  //     formik.setTouched({
  //       images: true
  //     });
  //   } else {
  //     onMountRef.current.images = true;
  //   }

  // }, [formik?.values?.images]);

  // React.useEffect(() => {
  //   if (forms?.gallery) {
  //     formik.setValues(forms?.gallery);
  //   }
  // }, []);

  React.useEffect(() => {
    if (!vehicle_id) {
      return;
    }

    (async () => {
      await getVehicleDetailsApiHandler({
        vehicleId: vehicle_id,
      });
    })();
  }, [vehicle_id]);

  React.useEffect(() => {
    if (galleryForm?.Carfax_Report_Url) {
      setIsCarfaxPaymentDone(true);
    }
  }, [galleryForm?.Carfax_Report_Url]);

  React.useEffect(() => {
    (async () => {
      const res = await getVehicleDetailsApiHandler({
        vehicleId: vehicle_id,
      });

      setSelectedVehicle(res?.data?.vehicle || null);
    })();
  }, []);

  // 1. Create refs for the parent and child elements

  // 3. Effect to measure and update the width
  React.useEffect(() => {
    const calculateWidth = () => {
      if (parentRef.current) {
        // Use clientWidth to get the inner width in pixels
        const width = parentRef.current.clientWidth;
        setParentWidth(width);
      }
    };

    // Run calculation on mount
    calculateWidth();

    // 4. Set up an event listener for responsiveness
    window.addEventListener('resize', calculateWidth);

    // 5. Cleanup the listener when the component unmounts
    return () => {
      window.removeEventListener('resize', calculateWidth);
    };
  }, []);
  // useEffect end...

  console.log(formik, parentRef, parentWidth, `Gallery_comp`);

  return (
    <>
      <Paper elevation={0} sx={paperContainer}>
        <Typography variant="body1" sx={subtitleText}>
          {t('subtitle')}
        </Typography>
      </Paper>

      <Divider />

      <Container sx={mainContainere}>
        <form
          onSubmit={formik.handleSubmit}
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
          ref={parentRef}
        >
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "2rem"
          }}>
            {isCarfaxPaymentDone ? (
              <>
                <Typography>
                  {/* Your vehicle Carfax report is here: */}
                  {t('Your vehicle Carfax report is here')}:
                </Typography>
                <Button
                  // variant="body1"
                  // sx={{
                  //   fontWeight: 600,
                  //   textAlign: "center",
                  // }}
                  sx={{
                    textDecoration: 'underline',
                    fontSize: '1.05rem',
                    fontWeight: '700',
                    textTransform: 'capitalize',
                  }}
                  onClick={getCarfaxReportHandler}
                >
                  {getCarfaxReportApiData?.isFetching ? <CircularProgress size={22} /> : 'View'}
                  {/* <a href="#" style={carFaxLink}>
                    View
                  </a> */}
                </Button>

                <img
                  src={CarfaxLogo}
                  style={{
                    height: '4rem',
                  }}
                />
              </>
            ) : null}
          </Box>

          <Box sx={{ marginBottom: '2rem' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1rem',
              }}
            >
              <Typography sx={sectionTitle}>{t('uploadVideo')}</Typography>
              {formik.values?.Vehicle_video && typeof formik.values?.Vehicle_video === 'string' ? (
                <Button
                  sx={{
                    padding: '0',
                  }}
                  onClick={() => setOpenViewVideoModal(true)}
                  disabled={
                    !isVehicleDataEditEnabled({
                      car: selectedVehicle,
                    })
                  }
                >
                  {t('viewCurrentVideo')}
                </Button>
              ) : null}
            </Box>

            <Box sx={videoUploadContainer}>
              <Box>
                <img
                  src={videoIcon}
                  style={{
                    width: '2rem',
                  }}
                />
              </Box>
              <Box sx={{ flex: 1, textAlign: 'center' }}>
                {formik.values?.Vehicle_video && typeof formik.values?.Vehicle_video !== 'string' ? (
                  <Typography variant="body2" color="primary">
                    {formik.values?.Vehicle_video?.name}
                  </Typography>
                ) : (
                  <>
                    {t('dropVideoHere')}
                    {formik?.touched?.Vehicle_video && formik?.errors?.Vehicle_video ? (
                      <FieldErrorText>{`(${formik.errors?.Vehicle_video})`}</FieldErrorText>
                    ) : (
                      ''
                    )}
                  </>
                )}
              </Box>
              <Button
                variant="contained"
                component="label"
                startIcon={<CloudUploadIcon />}
                sx={uploadButton}
                disabled={
                  !isVehicleDataEditEnabled({
                    car: selectedVehicle,
                  })
                }
              >
                {t('browsevideo')}
                <input
                  type="file"
                  hidden
                  accept="video/mp4,video/avi,video/3gp,video/mkv"
                  onChange={handleVideoChange}
                  disabled={
                    !isVehicleDataEditEnabled({
                      car: selectedVehicle,
                    })
                  }
                />
              </Button>
            </Box>
          </Box>

          <Divider sx={{ marginBottom: '2rem' }} />

          {formik?.touched?.images && formik?.errors?.images && (
            <Box
              sx={{
                ...errorContainer,
                justifyContent: 'flex-start',
              }}
            >
              <FieldErrorText>{formik?.errors?.images}</FieldErrorText>
            </Box>
          )}

          <Box sx={{ marginBottom: '2rem' }}>
            <Typography sx={sectionTitle}>
              {t('exteriorOfTheCar')} <span style={{ color: 'red' }}>{t('requiredField')}</span>
            </Typography>
            <Grid container spacing={2} sx={{...imagesGridContainer, maxWidth: parentWidth}}>
              {formik?.values?.images?.['Exterior Of The Car'].map((label, labelIdx) => {
                return (
                  <Grid item size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }} key={`exterior-${labelIdx}`} sx={{...imageGridContainer, ...imageIndividualImageGridContainer }}>
                    <Box sx={imageInputContainer}>
                      <input
                        // ref={imagesInputsRef}
                        type="file"
                        accept="image/*"
                        style={hiddenFileInput}
                        onChange={(e) => {
                          if (!e?.target?.files?.[0]) {
                            return;
                          }

                          let images = formik?.values?.images?.['Exterior Of The Car']?.map((item, itemIdx) => {
                            if (itemIdx === labelIdx) {
                              return e?.target?.files?.[0];
                            } else {
                              return item;
                            }
                          });
                          formik.setValues((values) => {
                            return {
                              ...values,
                              images: {
                                ...values?.images,
                                ['Exterior Of The Car']: images,
                              },
                            };
                          });
                          // imagesInputsRef.current.value = "";
                        }}
                        disabled={
                          !isVehicleDataEditEnabled({
                            car: selectedVehicle,
                          })
                        }
                      />
                      {!label ? (
                        <Box sx={addImageContent}>
                          {/* <AddPhotoAlternate sx={imagePlaceholderIcon} /> */}
                          <img src={imagePlaceholderIcon} />
                          <Typography sx={addImageText}>{exteriorLabels[labelIdx]}</Typography>
                        </Box>
                      ) : isLinkRegex.test(label) ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            position: 'absolute',
                            bottom: '0.5rem',
                            left: '0.5rem',
                            zIndex: '50',
                          }}
                        >
                          <img
                            src={checkmarkIcon}
                            style={{
                              width: '2rem',
                              height: '2rem',
                            }}
                          />
                          <Typography
                            sx={{
                              color: theme.palette.background.paper,
                              fontWeight: '500',
                            }}
                          >
                            Uploaded
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>

                    {!label ? (
                      <Box sx={exampleImagesContainer}>
                        <Tooltip
                          arrow
                          title={
                            <ExampleImagesPopup
                              images={
                                labelIdx === 0
                                  ? [extImgEx1, extImgEx2, extImgEx3]
                                  : labelIdx === 1
                                    ? [driverSide1, driverSide2, driverSide3]
                                    : labelIdx === 2
                                      ? [passengerSide1, passengerSide2, passengerSide3]
                                      : labelIdx === 3
                                        ? [rearSide1, rearSide2, rearSide3]
                                        : []
                              }
                            />
                          }
                          sx={{
                            backgroundColor: `${theme.palette.background.paper} !important`,
                          }}
                          slotProps={{
                            tooltip: {
                              sx: {
                                maxWidth: 'none',
                              },
                            },
                            popper: {
                              sx: {
                                '& .MuiTooltip-tooltip': {
                                  maxWidth: 'none', // For previous issue: ensure full width
                                  whiteSpace: 'normal', // For previous issue: ensure text wraps

                                  // 👇 Key changes for color:
                                  backgroundColor: theme.palette.common.white, // Set your desired background color
                                  color: theme.palette.text.primary, // Set your desired text color for content
                                  boxShadow: `3px 3px 5px rgba(0, 0, 0, 0.5),
                                      -1.5px -1.5px 5px rgba(0, 0, 0, 0.5)
                                    `, // More subtle, common dark shadow
                                },
                                '& .MuiTooltip-arrow': {
                                  color: theme.palette.common.white, // Match arrow color to tooltip background
                                },
                              },
                            },
                          }}
                        >
                          <InfoOutline
                            sx={{
                              cursor: 'pointer',
                              fill: `${theme.palette.text.disabled} !important`,
                            }}
                          />
                        </Tooltip>
                      </Box>
                    ) : null}

                    {label ? (
                      <ImageDeleteContainer imageList={'Exterior Of The Car'} formik={formik} idx={labelIdx} />
                    ) : null}

                    {label ? (
                      <>
                        <img
                          src={typeof label === 'string' ? label : URL.createObjectURL(label)}
                          alt={label}
                          style={{
                            ...imageStyle,
                          }}
                        />

                        <Box
                          sx={{
                            ...imageStyle,
                            position: 'absolute',
                            background: `linear-gradient(to top right, rgba(0, 0, 0, 0.3) 0%, transparent 100%)`,
                          }}
                        ></Box>
                      </>
                    ) : null}
                  </Grid>
                );
              })}

              <Grid item size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }} sx={{...imageGridContainer, ...imageIndividualImageGridContainer }}>
                <Box sx={imageInputContainer}>
                </Box>

                <Box
                  sx={{
                    ...imageStyle,
                    position: 'absolute',
                  }}
                >
                  <Button
                    sx={{
                      width: "100%",
                      height: "50%",
                      fontSize: "1.25rem"
                    }}
                    onClick={() => {
                      formik.setValues?.(values => {
                        return {
                          ...values,
                          images: {
                            ...values?.images,
                            ["Exterior Of The Car"]: [
                              ...formik?.values?.images?.['Exterior Of The Car'],
                              ""
                            ]
                          }
                        }
                      })
                    }}
                  >
                    Add more images
                  </Button>

                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ marginBottom: '2rem' }}>
            <Typography sx={sectionTitle}>
              {t('interiorOfTheCar')} <span style={{ color: 'red' }}>{t('requiredField')}</span>
            </Typography>
            <Grid container spacing={2} sx={{...imagesGridContainer, maxWidth: parentWidth}}>
              {formik?.values?.images?.['Interior Of The Car'].map((label, labelIdx) => {
                return (
                  <Grid item size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }} key={`interior-${labelIdx}`} sx={{...imageGridContainer, ...imageIndividualImageGridContainer}}>
                    <Box sx={imageInputContainer}>
                      <input
                        // ref={imagesInputsRef}
                        type="file"
                        accept="image/*"
                        style={hiddenFileInput}
                        onChange={(e) => {
                          if (!e?.target?.files?.[0]) {
                            return;
                          }

                          let images = formik?.values?.images?.['Interior Of The Car']?.map((item, itemIdx) => {
                            if (itemIdx === labelIdx) {
                              return e?.target?.files?.[0];
                            } else {
                              return item;
                            }
                          });
                          formik.setValues((values) => {
                            return {
                              ...values,
                              images: {
                                ...values?.images,
                                ['Interior Of The Car']: images,
                              },
                            };
                          });

                          // imagesInputsRef.current.value = "";
                        }}
                        disabled={
                          !isVehicleDataEditEnabled({
                            car: selectedVehicle,
                          })
                        }
                      />
                      {!label ? (
                        <Box sx={addImageContent}>
                          {/* <AddPhotoAlternate sx={imagePlaceholderIcon} /> */}
                          <img src={imagePlaceholderIcon} />
                          <Typography sx={addImageText}>{interiorLabels[labelIdx]}</Typography>
                        </Box>
                      ) : isLinkRegex.test(label) ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            position: 'absolute',
                            bottom: '0.5rem',
                            left: '0.5rem',
                            zIndex: '50',
                          }}
                        >
                          <img
                            src={checkmarkIcon}
                            style={{
                              width: '2rem',
                              height: '2rem',
                            }}
                          />
                          <Typography
                            sx={{
                              color: theme.palette.background.paper,
                              fontWeight: '500',
                            }}
                          >
                            Uploaded
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>

                    {!label ? (
                      <Box sx={exampleImagesContainer}>
                        <Tooltip
                          arrow
                          title={
                            <ExampleImagesPopup
                              images={
                                labelIdx === 0
                                  ? [intImgEx1, intImgEx2, intImgEx3]
                                  : labelIdx === 1
                                    ? [consoleSide1, consoleSide2, consoleSide3]
                                    : labelIdx === 2
                                      ? [steeringSide1, steeringSide2, steeringSide3]
                                      : labelIdx === 3
                                        ? [backseatSide1, backseatSide2, backseatSide3]
                                        : []
                              }
                            />
                          }
                          sx={{
                            backgroundColor: `${theme.palette.background.paper} !important`,
                          }}
                          slotProps={{
                            tooltip: {
                              sx: {
                                maxWidth: 'none',
                              },
                            },
                            popper: {
                              sx: {
                                '& .MuiTooltip-tooltip': {
                                  maxWidth: 'none', // For previous issue: ensure full width
                                  whiteSpace: 'normal', // For previous issue: ensure text wraps

                                  // 👇 Key changes for color:
                                  backgroundColor: theme.palette.common.white, // Set your desired background color
                                  color: theme.palette.text.primary, // Set your desired text color for content
                                  boxShadow: `3px 3px 5px rgba(0, 0, 0, 0.5),
                                      -1.5px -1.5px 5px rgba(0, 0, 0, 0.5)
                                    `, // More subtle, common dark shadow
                                },
                                '& .MuiTooltip-arrow': {
                                  color: theme.palette.common.white, // Match arrow color to tooltip background
                                },
                              },
                            },
                          }}
                        >
                          <InfoOutline
                            sx={{
                              cursor: 'pointer',
                              fill: `${theme.palette.text.disabled} !important`,
                            }}
                          />
                        </Tooltip>
                      </Box>
                    ) : null}

                    {label ? (
                      <ImageDeleteContainer imageList={'Interior Of The Car'} formik={formik} idx={labelIdx} />
                    ) : null}

                    {label ? (
                      <>
                        <img
                          src={typeof label === 'string' ? label : URL.createObjectURL(label)}
                          alt={label}
                          style={imageStyle}
                        />
                        <Box
                          sx={{
                            ...imageStyle,
                            position: 'absolute',
                            background: `linear-gradient(to top right, rgba(0, 0, 0, 0.3) 0%, transparent 100%)`,
                          }}
                        ></Box>
                      </>
                    ) : null}
                  </Grid>
                );
              })}

              <Grid item size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }} sx={{...imageGridContainer, ...imageIndividualImageGridContainer}}>
                <Box sx={imageInputContainer}>
                </Box>

                <Box
                  sx={{
                    ...imageStyle,
                    position: 'absolute',
                  }}
                >
                  <Button
                    sx={{
                      width: "100%",
                      height: "50%",
                      fontSize: "1.25rem"
                    }}
                    onClick={() => {
                      formik.setValues?.(values => {
                        return {
                          ...values,
                          images: {
                            ...values?.images,
                            ["Interior Of The Car"]: [
                              ...formik?.values?.images?.['Interior Of The Car'],
                              ""
                            ]
                          }
                        }
                      })
                    }}
                  >
                    Add more images
                  </Button>

                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ marginBottom: '2rem' }}>
            <Typography sx={sectionTitle}>
              {t('rimsOfTheCar')} <span style={{ color: 'red' }}>{t('requiredField')}</span>
            </Typography>
            <Grid container spacing={2} sx={{...imagesGridContainer, maxWidth: parentWidth}}>
              {formik?.values?.images?.['Rims Of The Car'].map((label, labelIdx) => {
                return (
                  <Grid item size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }} key={`rims-${labelIdx}`} sx={{...imageGridContainer, ...imageIndividualImageGridContainer}}>
                    <Box sx={imageInputContainer}>
                      <input
                        // ref={imagesInputsRef}
                        type="file"
                        accept="image/*"
                        style={hiddenFileInput}
                        onChange={(e) => {
                          if (!e?.target?.files?.[0]) {
                            return;
                          }

                          let images = formik?.values?.images?.['Rims Of The Car']?.map((item, itemIdx) => {
                            if (itemIdx === labelIdx) {
                              return e?.target?.files?.[0];
                            } else {
                              return item;
                            }
                          });
                          formik.setValues((values) => {
                            return {
                              ...values,
                              images: {
                                ...values?.images,
                                ['Rims Of The Car']: images,
                              },
                            };
                          });

                          // imagesInputsRef.current.value = "";
                        }}
                        disabled={
                          !isVehicleDataEditEnabled({
                            car: selectedVehicle,
                          })
                        }
                      />
                      {!label ? (
                        <Box sx={addImageContent}>
                          <img src={imagePlaceholderIcon} />
                          <Typography sx={addImageText}>{rimsLabels[labelIdx]}</Typography>
                        </Box>
                      ) : isLinkRegex.test(label) ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            position: 'absolute',
                            bottom: '0.5rem',
                            left: '0.5rem',
                            zIndex: '50',
                          }}
                        >
                          <img
                            src={checkmarkIcon}
                            style={{
                              width: '2rem',
                              height: '2rem',
                            }}
                          />
                          <Typography
                            sx={{
                              color: theme.palette.background.paper,
                              fontWeight: '500',
                            }}
                          >
                            Uploaded
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>

                    {!label ? (
                      <Box sx={exampleImagesContainer}>
                        <Tooltip
                          arrow
                          title={<ExampleImagesPopup images={[rimsImgEx1, rimsImgEx2, rimsImgEx3]} />}
                          sx={{
                            backgroundColor: `${theme.palette.background.paper} !important`,
                          }}
                          slotProps={{
                            tooltip: {
                              sx: {
                                maxWidth: 'none',
                              },
                            },
                            popper: {
                              sx: {
                                '& .MuiTooltip-tooltip': {
                                  maxWidth: 'none', // For previous issue: ensure full width
                                  whiteSpace: 'normal', // For previous issue: ensure text wraps

                                  // 👇 Key changes for color:
                                  backgroundColor: theme.palette.common.white, // Set your desired background color
                                  color: theme.palette.text.primary, // Set your desired text color for content
                                  boxShadow: `3px 3px 5px rgba(0, 0, 0, 0.5),
                                      -1.5px -1.5px 5px rgba(0, 0, 0, 0.5)
                                    `, // More subtle, common dark shadow
                                },
                                '& .MuiTooltip-arrow': {
                                  color: theme.palette.common.white, // Match arrow color to tooltip background
                                },
                              },
                            },
                          }}
                        >
                          <InfoOutline
                            sx={{
                              cursor: 'pointer',
                              fill: `${theme.palette.text.disabled} !important`,
                            }}
                          />
                        </Tooltip>
                      </Box>
                    ) : null}

                    {label ? (
                      <ImageDeleteContainer imageList={'Rims Of The Car'} formik={formik} idx={labelIdx} />
                    ) : null}

                    {label ? (
                      <>
                        <img
                          src={typeof label === 'string' ? label : URL.createObjectURL(label)}
                          alt={label}
                          style={imageStyle}
                        />

                        <Box
                          sx={{
                            ...imageStyle,
                            position: 'absolute',
                            background: `linear-gradient(to top right, rgba(0, 0, 0, 0.3) 0%, transparent 100%)`,
                          }}
                        ></Box>
                      </>
                    ) : null}
                  </Grid>
                );
              })}

              <Grid item size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }} sx={{...imageGridContainer, ...imageIndividualImageGridContainer}}>
                <Box sx={imageInputContainer}>
                </Box>

                <Box
                  sx={{
                    ...imageStyle,
                    position: 'absolute',
                  }}
                >
                  <Button
                    sx={{
                      width: "100%",
                      height: "50%",
                      fontSize: "1.25rem"
                    }}
                    onClick={() => {
                      formik.setValues?.(values => {
                        return {
                          ...values,
                          images: {
                            ...values?.images,
                            ["Rims Of The Car"]: [
                              ...formik?.values?.images?.["Rims Of The Car"],
                              ""
                            ]
                          }
                        }
                      })
                    }}
                  >
                    Add more images
                  </Button>

                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ marginBottom: '2rem' }}>
            <Typography sx={sectionTitle}>
              {t('damagePhotos')} {selectedVehicle?.Ext_Mint_Condition === 0 ||
                selectedVehicle?.Int_Mint_Condition === 0 ? 
                  <span style={{ color: 'red' }}>{t('requiredField')}</span> : 
                  null
                }
            </Typography>
            <Grid
              container
              spacing={2}
              sx={{
                ...imagesGridContainer,
                maxWidth: parentWidth,
                alignItems: 'flex-start',
              }}
            >
              {formik?.values?.images?.['Damage Photos'].map((label, labelIdx) => {
                return (
                  <Grid
                    container
                    size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }}
                    sx={{
                      ...imageIndividualImageGridContainer
                    }}
                  >
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }} key={`damage-${labelIdx}`} sx={{...imageGridContainer}}>
                      <Box sx={imageInputContainer}>
                        <Button
                          sx={{
                            ...hiddenFileInput,
                            zIndex: "100"
                          }}
                          onClick={() => {
                            setDamagePhotosModal(damagePhotosModal => {
                              return {
                                ...damagePhotosModal,
                                open: true,
                                idx: labelIdx,
                                image: formik?.values?.images?.["Damage Photos"]?.[labelIdx],
                                description: formik?.values?.notes?.["Damage Photos"]?.[labelIdx],
                                isEditingDesc: false,
                              }
                            })
                          }}
                        />
                        {/* <input
                          // ref={imagesInputsRef}
                          type="file"
                          accept="image/*"
                          style={hiddenFileInput}
                          onChange={(e) => {
                            if (!e?.target?.files?.[0]) {
                              return;
                            }

                            let images = formik?.values?.images?.['Damage Photos']?.map((item, itemIdx) => {
                              if (itemIdx === labelIdx) {
                                return e?.target?.files?.[0];
                              } else {
                                return item;
                              }
                            });
                            formik.setValues((values) => {
                              return {
                                ...values,
                                images: {
                                  ...values?.images,
                                  ['Damage Photos']: images,
                                },
                              };
                            });

                            // imagesInputsRef.current.value = "";
                          }}
                          disabled={
                            !isVehicleDataEditEnabled({
                              car: selectedVehicle,
                            })
                          }
                        /> */}
                        {!label ? (
                          <Box sx={addImageContent}>
                            {/* <AddPhotoAlternate sx={imagePlaceholderIcon} /> */}
                            <img src={imagePlaceholderIcon} />
                            <Typography sx={addImageText}>{t('addPicture')}</Typography>
                          </Box>
                        ) : isLinkRegex.test(label) ? (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              position: 'absolute',
                              bottom: '0.5rem',
                              left: '0.5rem',
                              zIndex: '50',
                            }}
                          >
                            <img
                              src={checkmarkIcon}
                              style={{
                                width: '2rem',
                                height: '2rem',
                              }}
                            />
                            <Typography
                              sx={{
                                color: theme.palette.background.paper,
                                fontWeight: '500',
                              }}
                            >
                              Uploaded
                            </Typography>
                          </Box>
                        ) : null}
                      </Box>

                      {label ? <ImageDeleteContainer imageList={'Damage Photos'} formik={formik} idx={labelIdx} /> : null}

                      {label ? (
                        <>
                          <img
                            src={typeof label === 'string' ? label : URL.createObjectURL(label)}
                            alt={label}
                            style={imageStyle}
                          />

                          <Box
                            sx={{
                              ...imageStyle,
                              cursor: 'pointer',
                              position: 'absolute',
                              background: `linear-gradient(to top right, rgba(0, 0, 0, 0.3) 0%, transparent 100%)`,
                            }}
                          ></Box>
                        </>
                      ) : null}
                    </Grid>
                    {
                      [
                        ...formik?.values?.notes?.["Damage Photos"], 
                        // ...formik?.values?.Damage_Multiple_Label?.split?.(", ")
                      ]?.map((note, noteIdx) => {
                        if (noteIdx !== labelIdx || !note) {
                          return;
                        }

                        return (
                          <Tooltip
                            title={note}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "0.25rem",
                              }}
                            >
                              <Typography
                                sx={{
                                  textAlign: "center",
                                  "& :hover": { cursor: "pointer" },
                                }}
                              >
                                Note: <span
                                  style={{
                                    borderBottom: `1px solid ${theme.palette.text.primary}`,
                                  }}
                                >
                                  {getShortenedString({
                                    string: note,
                                    totalChars: 15
                                  })}
                                </span>
                              </Typography>
                              <Edit
                                sx={{
                                  fontSize: "1.15rem",
                                  cursor: "pointer"
                                }}
                                onClick={() => {
                                  setDamagePhotosModal(damagePhotosModal => {
                                    return {
                                      ...damagePhotosModal,
                                      open: true,
                                      idx: labelIdx,
                                      description: note,
                                      image: formik?.values?.images?.["Damage Photos"]?.[labelIdx],
                                      isEditingDesc: true,
                                    }
                                  })
                                }}
                              />
                            </Box>
                          </Tooltip>
                        )
                      })}
                    
                      {formik?.errors?.notes?.['Damage Photos']?.[labelIdx] && formik?.touched?.notes?.['Damage Photos']?.[labelIdx] ? (
                        <FieldErrorText>
                          {formik?.errors?.notes?.['Damage Photos']?.[labelIdx]}
                        </FieldErrorText>
                      ) : null}

                    {/* {formik?.errors?.notes?.['Damage Photos']?.[labelIdx] && formik?.touched?.notes?.['Damage Photos']?.[labelIdx] ? (
                      <FieldErrorText>
                        {formik?.errors?.notes?.['Damage Photos']?.[labelIdx]}
                      </FieldErrorText>
                    ) : null} */}
                  </Grid>
                );
              })}

              <Grid item size={{ xs: 6, sm: 6, md: 2.4, lg: 2.4 }} sx={{...imageGridContainer, ...imageIndividualImageGridContainer}}>
                <Box sx={imageInputContainer}>
                </Box>

                <Box
                  sx={{
                    ...imageStyle,
                    position: 'absolute',
                  }}
                >
                  <Button
                    sx={{
                      width: "100%",
                      height: "50%",
                      fontSize: "1.25rem"
                    }}
                    onClick={() => {
                      formik.setValues?.(values => {
                        return {
                          ...values,
                          images: {
                            ...values?.images,
                            ["Damage Photos"]: [
                              ...formik?.values?.images?.['Damage Photos'],
                              ""
                            ]
                          },
                          notes: {
                            ...values?.notes,
                            ["Damage Photos"]: [
                              ...formik?.values?.notes?.['Damage Photos'],
                              ""
                            ]
                          }
                        }
                      })
                    }}
                  >
                    Add more images
                  </Button>

                </Box>
              </Grid>
            </Grid>
          </Box>

          {!isCarfaxPaymentDone && !generalInfoForm?.Carfax_Report_Url ? (
            <Box sx={carfaxFullSection}>
              {/* <div id="paypal-button-container" className="mt-4"></div> */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                <Typography variant="body1" sx={carfaxHeadline}>
                  {t('sellFasterWithCarfax')}
                </Typography>
                <img
                  src={CarfaxLogo}
                  style={{
                    height: '4rem',
                  }}
                />
              </Box>

              <Typography variant="body2" sx={carfaxSubHeadline}>
                {t('carfaxSubheadline')}
              </Typography>

              {/* <Typography sx={carfaxDisclaimer}>
                <span>{t('note')}</span> {t('carfaxDisclaimer')}
              </Typography> */}

              <Typography>
                {t(`A CARFAX report builds instant trust by giving buyers verified details about your vehicle’s history—accidents, service records, mileage, and any liens. With this information upfront, buyers feel confident, bid higher, and stay competitive. It also verifies your listing, making your car stand out and sell faster at a better value.`)}
              </Typography>

              <Typography
                sx={{
                  marginTop: "0.5rem",
                  fontWeight: "600"
                }}
              >
                {t(`Add a CARFAX report to your listing for only $66`)}
              </Typography>

              <Box sx={paypalButtonsGroup}>
                {!generalInfoForm?.Carfax_Report_Url && !isCarfaxPaymentInProgress ? (
                  <PayPalScriptProvider
                    options={{
                      'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
                      currency: 'CAD',
                    }}
                  >
                    {/* Conditionally render buttons only when paypalOrderId is available */}
                    {/* {paypalOrderId && ( */}
                    <PayPalButtons
                      style={{ layout: 'vertical', color: 'blue', shape: 'rect', label: 'paypal' }}
                      createOrder={async () => {
                        const orderId = await createPaypalOrder();
                        return orderId;
                      }} // Use the function that returns your pre-generated ID
                      onApprove={async (data, actions) => {
                        console.log(data, actions, `onApprove`);
                        await onPaymentProcessingHandler(data, actions);
                      }}
                      onError={onPaymentErrorHandler}
                      // You might also want to add onCancel for handling canceled payments
                      onCancel={(data) => console.log(t('paymentCancelled'), data)}
                    />
                    {/* )} */}
                    {/* {!paypalOrderId && <div>{t("paypalOrderGeneration")}</div>} */}
                  </PayPalScriptProvider>
                ) : null}
                {/* <div id="paypal-button-container" className="mt-4"></div> */}
                {/* <button
                style={paypalButtonStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  // handleCarfaxPayment();
                }}
              >
                <img
                  src="https://www.paypalobjects.com/webstatic/icon/pp258.png"
                  alt="PayPal"
                  width={24}
                  height={24}
                />
                PayPal
              </button>

              <button style={cardButtonStyle}>
                <img
                  src="https://img.icons8.com/ios-filled/50/2B52D2/bank-card-back-side.png"
                  alt="Card"
                  width={24}
                  height={24}
                />
                Debit/Credit Card
              </button> */}
              </Box>
            </Box>
          ) : null}

          <Divider sx={{ marginBottom: '2rem' }} />

          <NavigationButtons
            isLoading={updateCarApiData?.isFetching || updateCarOnRelistPendingApiData?.isLoading}
            previousFormHandler={previousFormHandler}
          />
        </form>
      </Container>

      {damagePhotosModal?.open ? (
        <Modal
          open={true}
          onClose={() => {
            setDamagePhotosModal({ ...damagePhotosModalInit });
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          aria-labelledby="vehicle-added-modal-title"
          aria-describedby="vehicle-added-modal-description"
        >
          <DamagePhotosModal
            onSubmit={({ image, description }) => {
              onChangeDamagePhotosHandler(
                damagePhotosModal?.isEditingDesc ? null : image,
                description,
                damagePhotosModal?.idx
              );
            }}
            onClose={() => {
              setDamagePhotosModal({ ...damagePhotosModalInit });
            }}
            desc={damagePhotosModal?.description}
            img={damagePhotosModal?.image}
            isEditingDesc={damagePhotosModal?.isEditingDesc}
          />
        </Modal>
      ) : null}

      {isSuccess ? (
        <Modal
          open={true}
          onClose={() => { }}
          aria-labelledby="vehicle-added-modal-title"
          aria-describedby="vehicle-added-modal-description"
        >
          <VehicleAddedModal
            handleClose={onSuccessCallback}
            car={selectedVehicle}
            images={forms?.gallery?.images}
            isEditing={isEditing}
            changeTabHandler={changeTabHandler}
          />
        </Modal>
      ) : null}
      <ViewVideoModal
        open={openViewVideoModal}
        onClose={() => setOpenViewVideoModal(false)}
        video={formik.values.Vehicle_video}
      />

      {/* {carfaxReportUrl ? (
        <Modal
          open={true}
          onClose={() => {}}
          aria-labelledby="carfax-report-title"
          aria-describedby="carfax-report-description"
        >
          <PdfViewer
            pdfUrl={carfaxReportUrl}
          />
        </Modal>
      ) : null} */}
    </>
  );
};

export default Gallery;
